(() => {
  const cardSelector = '#gbbBundle .gbbProductItem';
  const categoryClass = 'gbbArchiduchesseProductCategory';
  const defaultBundleConfig = {
    introDescription: 'Composez votre coffret sur mesure.',
    ctaAddLabel: 'Ajouter mon coffret au panier',
    ctaPendingLabel: 'Ajout en cours...',
    ctaContinueLabel: 'Continuer',
    modalAddLabel: 'Ajouter au coffret',
    loadingLabel: 'Chargement de votre coffret...',
    pairCount: 3,
    iconUrl: 'https://cdn.shopify.com/s/files/1/0563/4562/4775/files/PICTO_CHAUSSETTE_BLANC_3.png?v=1773769544',
    excludedProducts: []
  };
  const currentLocale = (() => {
    const htmlLang = String(document.documentElement.lang || '').toLowerCase();
    const pathLocale = String(window.location.pathname || '').split('/').filter(Boolean)[0];

    if (htmlLang.startsWith('en') || pathLocale === 'en') return 'en';
    return 'fr';
  })();
  const isEnglishLocale = currentLocale === 'en';
  const labelsByLocale = {
    fr: {
      addBundleToCart: 'Ajouter mon coffret au panier',
      addToBundle: 'Ajouter au coffret',
      addPending: 'Ajout en cours...',
      applyFilters: 'Appliquer',
      availability: 'Disponibilité',
      bundleIntro: 'Composez votre coffret sur mesure.',
      carouselNextPage: 'Page suivante',
      carouselPreviousPage: 'Page précédente',
      chooseOptions: 'Choisir les options',
      chooseProduct: 'Choisir',
      clearFilters: 'TOUT SUPPRIMER',
      close: 'Fermer',
      closeFilters: 'Fermer les filtres',
      color: 'Couleur',
      continue: 'Continuer',
      emptyFilterOption: 'Aucune option',
      filterProductAria: 'Filtres produits',
      filters: 'FILTRES',
      filteredSuffix: ' filtrés :',
      filterHeading: 'Filtrer',
      inStock: 'En stock',
      loadMoreProducts: 'Charger plus de produits',
      loadingProducts: 'Chargement des produits...',
      loadingSizes: 'Chargement des tailles et disponibilités...',
      loadingBundle: 'Chargement de votre coffret...',
      quantity: 'Quantité',
      productSingular: 'produit',
      productPlural: 'produits',
      pairSelectedSingular: 'paire sélectionnée',
      pairSelectedPlural: 'paires sélectionnées',
      removeFilter: 'Retirer le filtre',
      selectedProductSingular: 'Voir le produit sélectionné',
      selectedProductsPlural: 'Voir les produits sélectionnés',
      size: 'Taille',
      sizeSoldOutNotice: 'Cette taille est épuisée.',
      soldOut: 'SOLD OUT',
      stockLimit: 'Quantité max atteinte',
      type: 'Type de produit',
      unavailable: 'Épuisé',
      unavailableCombination: 'Combinaison non disponible',
      onePairAvailableNotice: '1 paire disponible pour cette taille.',
      oneSlotRemainingNotice: 'Il reste 1 place dans votre coffret.'
    },
    en: {
      addBundleToCart: 'Add my gift box to cart',
      addToBundle: 'Add to gift box',
      addPending: 'Adding...',
      applyFilters: 'Apply',
      availability: 'Availability',
      bundleIntro: 'Build your custom gift box.',
      carouselNextPage: 'Next page',
      carouselPreviousPage: 'Previous page',
      chooseOptions: 'Choose options',
      chooseProduct: 'Choose',
      clearFilters: 'CLEAR ALL',
      close: 'Close',
      closeFilters: 'Close filters',
      color: 'Colour',
      continue: 'Continue',
      emptyFilterOption: 'No option',
      filterProductAria: 'Product filters',
      filters: 'FILTERS',
      filteredSuffix: ' filtered:',
      filterHeading: 'Filter',
      inStock: 'In stock',
      loadMoreProducts: 'Load more products',
      loadingProducts: 'Loading products...',
      loadingSizes: 'Loading sizes and availability...',
      loadingBundle: 'Loading your gift box...',
      quantity: 'Quantity',
      productSingular: 'product',
      productPlural: 'products',
      pairSelectedSingular: 'pair selected',
      pairSelectedPlural: 'pairs selected',
      removeFilter: 'Remove filter',
      selectedProductSingular: 'View selected product',
      selectedProductsPlural: 'View selected products',
      size: 'Size',
      sizeSoldOutNotice: 'This size is sold out.',
      soldOut: 'SOLD OUT',
      stockLimit: 'Maximum quantity reached',
      type: 'Product type',
      unavailable: 'Sold out',
      unavailableCombination: 'Combination unavailable',
      onePairAvailableNotice: '1 pair available in this size.',
      oneSlotRemainingNotice: '1 spot left in your gift box.'
    }
  };
  const t = (key) => {
    const localeLabels = labelsByLocale[currentLocale] || labelsByLocale.fr;
    return localeLabels[key] || labelsByLocale.fr[key] || key;
  };
  const localizeBundleConfig = (config) => {
    if (!isEnglishLocale) return config;

    return Object.assign({}, config, {
      introDescription: t('bundleIntro'),
      ctaAddLabel: t('addBundleToCart'),
      ctaPendingLabel: t('addPending'),
      ctaContinueLabel: t('continue'),
      modalAddLabel: t('addToBundle'),
      loadingLabel: t('loadingBundle')
    });
  };
  const readBundleConfig = () => {
    const script = document.getElementById('archiduchesse-easybundle-config');
    if (!script) return localizeBundleConfig(defaultBundleConfig);

    try {
      return localizeBundleConfig(Object.assign({}, defaultBundleConfig, JSON.parse(script.textContent)));
    } catch (error) {
      console.warn('[archiduchesse] Config coffret invalide, utilisation des valeurs par défaut.', error);
      return localizeBundleConfig(defaultBundleConfig);
    }
  };
  const bundleConfig = readBundleConfig();
  const defaultExcludedProducts = [
    {
      handle: 'semainier-de-luxe-bleu',
      id: '8698921484617',
      title: 'Semainier Ciel Bleu De Luxe'
    },
    {
      handle: 'boite-trio',
      id: '6822997426375',
      title: 'Boite Trio'
    },
    {
      handle: 'bouclette-rayee-rouge-bleue',
      id: '6823018234055',
      title: 'Bouclette Rayée Rouge Bleue'
    },
    {
      handle: 'chaussettes-dinosaure',
      id: '9322159145289',
      title: 'Dinotopied'
    }
  ];
  const readExcludedProductsConfig = () => {
    if (Array.isArray(window.__archiduchesseEasyBundleExcludedProducts)) {
      return window.__archiduchesseEasyBundleExcludedProducts;
    }

    if (Array.isArray(bundleConfig.excludedProducts) && bundleConfig.excludedProducts.length) {
      return bundleConfig.excludedProducts;
    }

    const script = document.getElementById('archiduchesse-easybundle-excluded-products');
    if (!script) return defaultExcludedProducts;

    try {
      const parsedProducts = JSON.parse(script.textContent);
      return Array.isArray(parsedProducts) ? parsedProducts : defaultExcludedProducts;
    } catch (error) {
      return defaultExcludedProducts;
    }
  };
  const excludedProducts = readExcludedProductsConfig();
  const loadMoreSelector = '#gbbBundle .gbbLoadMoreProductsButton';
  const bundleIconUrl = bundleConfig.iconUrl;
  const postBundleRedirectScript = 'window.__archiduchesseEasyBundleAfterAdd && window.__archiduchesseEasyBundleAfterAdd();';
  const directCartAddButtonLabel = bundleConfig.ctaAddLabel;
  const directCartPendingButtonLabel = bundleConfig.ctaPendingLabel;
  const modalAddButtonLabel = bundleConfig.modalAddLabel;
  const filterDrawerId = 'gbbArchiduchesseCollectionFilters';
  const productsPerPage = 40;
  const collectionProductJsonPageSize = 250;
  const collectionProductJsonMaxPages = 8;
  const dynamicBundleCollectionHandle = 'chaussettes';
  const dynamicBundleProductJsonPageSize = 250;
  const dynamicBundleProductJsonMaxPages = 4;
  const dynamicBundleRecentCreatedAt = '2026-04-01';
  const storefrontApiVersion = '2026-04';
  const soldOutLabel = t('soldOut');
  const stockLimitLabel = t('stockLimit');
  const filterGroupConfig = [
    { key: 'size', label: t('size') },
    { key: 'color', label: t('color') },
    { key: 'type', label: t('type') },
    { key: 'availability', label: t('availability') }
  ];
  const filterOptionOrder = {
    type: isEnglishLocale
      ? ['Dress socks', 'De Luxe socks', 'Patterned socks', 'Short socks', 'Terry socks', 'Cocooning socks', 'Ankle socks', 'Glitter socks']
      : ['De Ville', 'De Luxe', 'Fantaisie', 'Courte', 'Bouclette', 'Cocooning', 'Socquette', 'Paillettées'],
    size: ['15/18', '19/22', '23/26', '27/30', '31/35', '36/41', '42/46', '43/46'],
    availability: [t('inStock'), t('unavailable')]
  };
  const selectedFilters = filterGroupConfig.reduce((memo, group) => {
    memo[group.key] = new Set();
    return memo;
  }, {});
  const ignoredSelector = [
    '.gbbProductAddButton',
    '.gbbProductButtonWrapper',
    '.gbbProductQuantityRemoveButton',
    '.gbbProductQuantityAddButton',
    '.gbbProductVariantOptionValue',
    'button',
    'a',
    'input',
    'select',
    'textarea',
    'label',
    'summary'
  ].join(',');
  const mutationRelevantSelector = [
    '#gbbBundle',
    '.gbbProductVariantModalContainer',
    '.gbbProductVariantModalDetailsContainer',
    '.gbbPreparingBundleMainContainer'
  ].join(',');
  let bundleProductCache = null;
  let categoryRetryCount = 0;
  let isDirectCartAddPending = false;
  let directCartAddResetTimer = null;
  let directCartFallbackTimer = null;
  let directCartFallbackAttempts = 0;
  let directCartInitialItemCount = null;
  let directCartSubmitTimer = null;
  let directCartSubmitAttempts = 0;
  let bundleAfterAddInFlight = false;
  let lastKnownCartItemCount = null;
  let bundleSettingsFromScript = null;
  let productMetaStarted = false;
  let productMetaFinished = false;
  let currentProductPage = 1;
  let collectionControlsSignature = '';
  let collectionPageRenderSignature = '';
  let collectionRenderRetryCount = 0;
  let lastInteractedProductKey = '';
  let scheduledCollectionRenderTimer = null;
  let isRenderingCollectionPage = false;
  let scheduledDomSync = false;
  let scheduledDomSyncPreviousProductCount = null;
  let scheduledDomSyncEnhanceRoots = [];
  let globalStockSyncTimer = null;
  let nativeTextTranslationTimers = [];
  let productActionLabelTimer = null;
  const productMetaCache = new Map();
  const productMetaRetryState = new Map();

  const normalizeText = (value) => (
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ')
  );

  const escapeRegExp = (value) => String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const englishSizeLabels = {
    '15/18': 'UK 0-2',
    '19/22': 'UK 3-5.5',
    '23/26': 'UK 6-8.5',
    '27/30': 'UK 9-12',
    '31/35': 'UK 12.5-2.5',
    '36/41': 'UK 4-7',
    '42/46': 'UK 8-11',
    '43/46': 'UK 9-11',
    '47/50': 'UK 12-14',
    '1/3': 'UK 1-3',
    '4/7': 'UK 4-7',
    '8/11': 'UK 8-11',
    'k0/2': 'Kids UK 0-2',
    'k3/5': 'Kids UK 3-5',
    'k6/8': 'Kids UK 6-8',
    'k9/11': 'Kids UK 9-11'
  };

  const getLocalizedSizeLabel = (value) => {
    const rawValue = String(value || '').trim();
    if (!isEnglishLocale) return rawValue;

    return englishSizeLabels[rawValue] || rawValue;
  };

  const replaceLocalizedSizeLabels = (text) => {
    if (!isEnglishLocale) return text;

    return Object.entries(englishSizeLabels).reduce((memo, [rawSize, localizedSize]) => (
      String(memo).replace(
        new RegExp(`(^|[^0-9])${escapeRegExp(rawSize)}(?=$|[^0-9])`, 'g'),
        `$1${localizedSize}`
      )
    ), String(text || ''));
  };

  const syncLocalizedSizeLabels = (root = document) => {
    if (!isEnglishLocale) return;

    const scope = root instanceof Element ? root : document;
    const roots = [
      ...(scope.matches && scope.matches('#gbbBundle, .gbbProductVariantModalContainer') ? [scope] : []),
      ...Array.from(scope.querySelectorAll ? scope.querySelectorAll('#gbbBundle, .gbbProductVariantModalContainer') : [])
    ];

    roots.forEach((targetRoot) => {
      const walker = document.createTreeWalker(targetRoot, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      let node = walker.nextNode();

      while (node) {
        textNodes.push(node);
        node = walker.nextNode();
      }

      textNodes.forEach((textNode) => {
        const localizedText = replaceLocalizedSizeLabels(textNode.nodeValue);
        if (localizedText !== textNode.nodeValue) textNode.nodeValue = localizedText;
      });
    });
  };

  const normalizeCategory = (value) => {
    const rawValue = String(value || '').trim();
    const key = normalizeText(rawValue);
    const labels = isEnglishLocale
      ? {
        'bouclette': 'Terry socks',
        'chaussettes bouclette': 'Terry socks',
        'chaussettes courtes': 'Short socks',
        'courte': 'Short socks',
        'chaussettes courte': 'Short socks',
        'chaussettes de luxe': 'De Luxe socks',
        'de luxe': 'De Luxe socks',
        'de luxe socks': 'De Luxe socks',
        'chaussettes de ville': 'Dress socks',
        'de ville': 'Dress socks',
        'de ville socks': 'Dress socks',
        'dress socks': 'Dress socks',
        'chaussettes cocooning': 'Cocooning socks',
        'cocooning': 'Cocooning socks',
        'cocooning socks': 'Cocooning socks',
        'chaussettes fantaisie': 'Patterned socks',
        'fantaisie': 'Patterned socks',
        'patterned socks': 'Patterned socks',
        'chaussettes pailletees': 'Glitter socks',
        'pailletees': 'Glitter socks',
        'paillettees': 'Glitter socks',
        'glitter socks': 'Glitter socks',
        'socquette': 'Ankle socks',
        'socquettes': 'Ankle socks',
        'ankle socks': 'Ankle socks',
        'collant': 'Tights',
        'collants': 'Tights',
        'tights': 'Tights',
        'sport': 'Sport socks',
        'sport socks': 'Sport socks',
        'lurex': 'Lurex socks',
        'recyclee': 'Recycled socks',
        'recycled': 'Recycled socks',
        'recycled socks': 'Recycled socks'
      }
      : {
        'bouclette': 'Bouclette',
        'chaussettes bouclette': 'Bouclette',
        'chaussettes courtes': 'Courte',
        'courte': 'Courte',
        'chaussettes courte': 'Courte',
        'chaussettes de luxe': 'De Luxe',
        'de luxe': 'De Luxe',
        'chaussettes de ville': 'De Ville',
        'de ville': 'De Ville',
        'chaussettes cocooning': 'Cocooning',
        'cocooning': 'Cocooning',
        'chaussettes fantaisie': 'Fantaisie',
        'fantaisie': 'Fantaisie',
        'chaussettes pailletees': 'Paillettées',
        'pailletees': 'Paillettées',
        'socquette': 'Socquette',
        'socquettes': 'Socquette'
      };

    if (labels[key]) return labels[key];

    const cleaned = rawValue
      .replace(/^chaussettes\s*:\s*/i, '')
      .replace(/^chaussettes\s+/i, '')
      .trim();

    if (!cleaned) return '';

    if (isEnglishLocale) return cleaned;

    return cleaned.toLowerCase().replace(/(^|\s|-)([a-zà-ÿ])/g, (match) => match.toUpperCase());
  };

  const getComparableValue = (value) => normalizeText(value).replace(/[^\w/]+/g, '-');

  const sortFilterOptions = (key, options) => {
    const preferredOrder = filterOptionOrder[key] || [];
    return Array.from(options).sort((a, b) => {
      const aIndex = preferredOrder.indexOf(a);
      const bIndex = preferredOrder.indexOf(b);

      if (aIndex !== -1 || bIndex !== -1) {
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
      }

      return a.localeCompare(b, currentLocale, { sensitivity: 'base' });
    });
  };

  const getTagValue = (product, prefix) => {
    const prefixKey = normalizeText(prefix);
    const tag = Array.isArray(product && product.tags)
      ? product.tags.find((item) => normalizeText(item).startsWith(prefixKey))
      : '';

    if (!tag) return '';
    return String(tag).split(':').slice(1).join(':').trim();
  };

  const getProductColor = (product) => {
    const colorFilter = getTagValue(product, 'Filtres:');
    if (colorFilter) return colorFilter;

    return getTagValue(product, 'Coloris:');
  };

  const readBundleSettingsFromScript = () => {
    if (bundleSettingsFromScript) return bundleSettingsFromScript;

    const script = Array.from(document.scripts).find((item) => (
      item.textContent && item.textContent.includes('window.tmpCartSettings2')
    ));

    if (!script) return null;

    const marker = 'window.tmpCartSettings2 = ';
    const text = script.textContent;
    const markerIndex = text.indexOf(marker);
    let objectStart = text.indexOf('{', markerIndex + marker.length);

    if (markerIndex === -1 || objectStart === -1) return null;

    let depth = 0;
    let end = -1;
    let isString = false;
    let isEscaped = false;

    for (let index = objectStart; index < text.length; index += 1) {
      const char = text[index];

      if (isString) {
        if (isEscaped) {
          isEscaped = false;
        } else if (char === '\\') {
          isEscaped = true;
        } else if (char === '"') {
          isString = false;
        }

        continue;
      }

      if (char === '"') {
        isString = true;
        continue;
      }

      if (char === '{') {
        depth += 1;
      } else if (char === '}') {
        depth -= 1;
        if (depth === 0) {
          end = index + 1;
          break;
        }
      }
    }

    if (end === -1) return null;

    try {
      bundleSettingsFromScript = JSON.parse(text.slice(objectStart, end));
    } catch (error) {
      bundleSettingsFromScript = null;
    }

    return bundleSettingsFromScript;
  };

  const getEasyBundleRuntime = () => window.gbb || null;

  const getEasyBundleSettings = () => {
    if (window.tmpCartSettings2) return window.tmpCartSettings2;
    const scriptSettings = readBundleSettingsFromScript();
    if (scriptSettings) return scriptSettings;

    const runtime = getEasyBundleRuntime();
    return runtime && runtime.settings ? runtime.settings : null;
  };

  const getEasyBundleAppSettings = () => {
    const runtime = getEasyBundleRuntime();
    const runtimeAppSettings = runtime && runtime.settings && runtime.settings.app;
    if (runtimeAppSettings) return runtimeAppSettings;

    const settings = getEasyBundleSettings();
    return (settings && settings.app)
      || (settings && settings.userData && settings.userData.customSettings)
      || null;
  };

  const getRawBundleProducts = () => {
    const settings = getEasyBundleSettings();

    return settings
      && settings.stepsConfigurationData
      && settings.stepsConfigurationData.productsData1
      && settings.stepsConfigurationData.productsData1.uniqueProductsData;
  };

  const getBundleProducts = () => {
    const rawProducts = getRawBundleProducts();

    if (!Array.isArray(rawProducts)) return [];
    if (bundleProductCache && bundleProductCache.source === rawProducts) return bundleProductCache;

    const byTitle = new Map();
    const products = rawProducts.filter((product) => !isExcludedProduct(product));

    products.forEach((product, index) => {
      const titleKey = normalizeText(product.title);
      if (!byTitle.has(titleKey)) byTitle.set(titleKey, []);
      byTitle.get(titleKey).push({ product, index });
    });

    bundleProductCache = { byTitle, products, rawProducts, source: rawProducts };
    return bundleProductCache;
  };

  const getTitle = (card) => {
    const title = card.querySelector('.gbbProductTitleOnly, .gbbProductItemTitle');
    return title ? title.textContent.trim() : '';
  };

  const getProductCount = () => document.querySelectorAll(cardSelector).length;

  const getTargetProductCount = () => {
    const { products } = getBundleProducts();
    return products && products.length ? products.length : 0;
  };

  const getAddButton = (card) => card.querySelector('.gbbProductAddButton');

  const getLoadMoreButton = () => document.querySelector(loadMoreSelector);

  const getModalContainer = () => document.querySelector('.gbbProductVariantModalContainer');

  const getNumericId = (value) => {
    const rawValue = String(value || '').trim();
    const match = rawValue.match(/(\d+)$/);
    return match ? match[1] : rawValue;
  };

  const getProductGid = (product) => {
    const numericId = getNumericId(product && (product.productId || product.id));
    return numericId ? `gid://shopify/Product/${numericId}` : '';
  };

  const getVariantNumericId = (variant) => getNumericId(
    variant && (variant.variant_id || variant.id || variant.admin_graphql_api_id)
  );

  const getStorefrontAccessToken = () => {
    const settings = getEasyBundleSettings();
    if (settings && settings.userData && settings.userData.storefrontAccessToken) {
      return settings.userData.storefrontAccessToken;
    }

    const runtime = getEasyBundleRuntime();
    return (runtime
      && runtime.settings
      && runtime.settings.userData
      && runtime.settings.userData.storefrontAccessToken)
      || '';
  };

  const chunkArray = (items, size) => {
    const chunks = [];

    for (let index = 0; index < items.length; index += size) {
      chunks.push(items.slice(index, index + size));
    }

    return chunks;
  };

  const isExcludedProduct = (product) => {
    if (!product) return false;

    const productHandle = normalizeText(product.handle);
    const productId = normalizeText(product.id || product.productId);
    const productTitle = normalizeText(product.title);

    return excludedProducts.some((excludedProduct) => (
      productHandle === normalizeText(excludedProduct.handle)
      || productId === normalizeText(excludedProduct.id)
      || productTitle === normalizeText(excludedProduct.title)
    ));
  };

  const removeExcludedProductsFromArray = (products) => (
    Array.isArray(products) ? products.filter((product) => !isExcludedProduct(product)) : products
  );

  const sanitizeEasyBundleSettings = () => {
    const settings = getEasyBundleSettings();
    const stepsConfigurationData = settings && settings.stepsConfigurationData;
    if (!stepsConfigurationData) return;

    const productsData = stepsConfigurationData.productsData1;
    if (productsData && Array.isArray(productsData.uniqueProductsData)) {
      const filteredProducts = removeExcludedProductsFromArray(productsData.uniqueProductsData);
      if (filteredProducts.length !== productsData.uniqueProductsData.length) {
        productsData.uniqueProductsData = filteredProducts;
        bundleProductCache = null;
      }
    }

    const defaultProductsData = stepsConfigurationData.defaultProductsData;
    if (defaultProductsData && Array.isArray(defaultProductsData.products)) {
      const filteredDefaultProducts = removeExcludedProductsFromArray(defaultProductsData.products);
      if (filteredDefaultProducts.length !== defaultProductsData.products.length) {
        defaultProductsData.products = filteredDefaultProducts;
        if (!filteredDefaultProducts.length) defaultProductsData.isDefaultProductsEnabled = false;
      }
    }

    ['productsForBundleLink', 'selectedProductsForBundleLink'].forEach((key) => {
      if (!Array.isArray(stepsConfigurationData[key])) return;

      const filteredProducts = removeExcludedProductsFromArray(stepsConfigurationData[key]);
      if (filteredProducts.length !== stepsConfigurationData[key].length) {
        stepsConfigurationData[key] = filteredProducts;
      }
    });
  };

  sanitizeEasyBundleSettings();

  const getElementAttributeText = (element) => [element, ...element.querySelectorAll('*')]
    .flatMap((item) => Array.from(item.attributes || [], (attribute) => attribute.value))
    .join(' ');

  const isExcludedCard = (card) => {
    const title = normalizeText(getTitle(card));
    if (excludedProducts.some((product) => title === normalizeText(product.title))) return true;

    const attributeText = getElementAttributeText(card);

    return excludedProducts.some((product) => (
      (product.handle && attributeText.includes(product.handle))
      || (product.id && attributeText.includes(product.id))
    ));
  };

  const removeExcludedProductCards = () => {
    Array.from(document.querySelectorAll(cardSelector)).forEach((card) => {
      if (isExcludedCard(card)) card.remove();
    });
  };

  const getCategoryFromProduct = (product) => {
    if (!product) return '';

    if (product.type && normalizeText(product.type) !== 'master') {
      return normalizeCategory(product.type);
    }

    const collection = Array.isArray(product.collectionNames) ? product.collectionNames[0] : '';
    if (collection) return normalizeCategory(collection);

    const categoryTag = Array.isArray(product.tags)
      ? product.tags.find((tag) => normalizeText(tag).startsWith('chaussettes:'))
      : '';

    return categoryTag ? normalizeCategory(categoryTag) : '';
  };

  const getModalCategoryFromProduct = (product) => {
    const category = getCategoryFromProduct(product);
    if (!category) return '';
    if (isEnglishLocale) return category;
    if (normalizeText(category).startsWith('chaussettes')) return category;
    return `Chaussettes ${category}`;
  };

  const buildCardProductMap = (cards) => {
    const { byTitle, products } = getBundleProducts();
    const productByCard = new WeakMap();
    const titleOccurrences = new Map();

    if (!products || !products.length) return productByCard;

    cards.forEach((card, cardIndex) => {
      const titleKey = normalizeText(getTitle(card));
      const candidates = byTitle.get(titleKey) || [];
      const occurrence = titleOccurrences.get(titleKey) || 0;
      titleOccurrences.set(titleKey, occurrence + 1);

      const attributeText = getElementAttributeText(card);
      const matchedByAttribute = candidates.find(({ product }) => (
        (product.handle && attributeText.includes(product.handle))
        || (product.productId && attributeText.includes(String(product.productId)))
        || (product.id && attributeText.includes(String(product.id)))
      ));

      if (matchedByAttribute) {
        productByCard.set(card, matchedByAttribute.product);
        return;
      }

      if (products[cardIndex] && normalizeText(products[cardIndex].title) === titleKey) {
        productByCard.set(card, products[cardIndex]);
        return;
      }

      if (candidates[occurrence]) {
        productByCard.set(card, candidates[occurrence].product);
        return;
      }

      if (candidates[0]) productByCard.set(card, candidates[0].product);
    });

    return productByCard;
  };

  const findProductForCard = (card, cardIndex, productByCard) => {
    if (productByCard && productByCard.has(card)) return productByCard.get(card);

    const { byTitle, products } = getBundleProducts();
    if (!products || !products.length) return null;

    const titleKey = normalizeText(getTitle(card));
    const candidates = byTitle.get(titleKey) || [];

    const attributeText = getElementAttributeText(card);

    const matchedByAttribute = candidates.find(({ product }) => (
      (product.handle && attributeText.includes(product.handle))
      || (product.productId && attributeText.includes(String(product.productId)))
      || (product.id && attributeText.includes(String(product.id)))
    ));

    if (matchedByAttribute) return matchedByAttribute.product;

    if (products[cardIndex] && normalizeText(products[cardIndex].title) === titleKey) {
      return products[cardIndex];
    }

    const sameTitleCards = Array.from(document.querySelectorAll(cardSelector))
      .filter((item) => normalizeText(getTitle(item)) === titleKey);
    const titleOccurrence = sameTitleCards.indexOf(card);

    if (candidates[titleOccurrence]) return candidates[titleOccurrence].product;
    if (candidates[0]) return candidates[0].product;

    return null;
  };

  const findProductByKey = (key) => {
    if (!key) return null;

    const { products } = getBundleProducts();
    if (!Array.isArray(products) || !products.length) return null;

    return products.find((product) => getProductKey(product) === key) || null;
  };

  const rememberProductForCard = (card) => {
    if (!card) return null;

    const existingProduct = findProductByKey(card.dataset.archiduchesseProductKey);
    if (existingProduct) {
      lastInteractedProductKey = getProductKey(existingProduct);
      return existingProduct;
    }

    const cards = Array.from(document.querySelectorAll(cardSelector));
    const productByCard = buildCardProductMap(cards);
    const product = findProductForCard(card, cards.indexOf(card), productByCard);
    const productKey = getProductKey(product);

    if (productKey) {
      card.dataset.archiduchesseProductKey = productKey;
      lastInteractedProductKey = productKey;
    }

    return product;
  };

  const findProductForModal = (modal) => {
    const { byTitle } = getBundleProducts();
    if (!byTitle || !byTitle.size || !modal) return null;

    const titleElement = modal.querySelector('.gbbProductItemTitle, .gbbProductTitleOnly');
    const titleKey = normalizeText(titleElement ? titleElement.textContent : '');
    const productFromLastInteractedCard = findProductByKey(lastInteractedProductKey);
    if (
      productFromLastInteractedCard
      && (!titleKey || normalizeText(productFromLastInteractedCard.title) === titleKey)
    ) {
      modal.dataset.archiduchesseProductKey = lastInteractedProductKey;
      return productFromLastInteractedCard;
    }

    const candidates = byTitle.get(titleKey) || [];
    if (candidates[0]) return candidates[0].product;

    return null;
  };

  const getVariantSelectedValues = (variant) => {
    const selectedOptions = Array.isArray(variant && variant.selectedOptions)
      ? variant.selectedOptions
      : Array.isArray(variant && variant.selected_options)
        ? variant.selected_options
        : [];
    const selectedValues = selectedOptions
      .map((option) => option && option.value)
      .filter(Boolean);
    const optionValues = [
      variant && variant.option1,
      variant && variant.option2,
      variant && variant.option3,
      ...(Array.isArray(variant && variant.options) ? variant.options : [])
    ].filter(Boolean);
    const title = variant && variant.title && normalizeText(variant.title) !== 'default title'
      ? [variant.title]
      : [];

    return Array.from(new Set([...selectedValues, ...optionValues, ...title]
      .map((value) => String(value || '').trim())
      .filter(Boolean)));
  };

  const getModalSelectedVariantValues = (modal) => (
    Array.from(modal.querySelectorAll('.gbbProductVariantOptionValue.gbbActiveVariant'))
      .map((option) => option.getAttribute('optionvalueid')
        || option.dataset.optionValue
        || option.dataset.value
        || option.dataset.archiduchesseRawValue
        || option.textContent)
      .map((value) => String(value || '').trim())
      .filter(Boolean)
  );

  const findVariantMetaForSelectedValues = (meta, selectedValues) => {
    const variants = meta && Array.isArray(meta.variants) ? meta.variants : [];
    if (!variants.length) return null;

    const normalizedSelectedValues = selectedValues.map(normalizeText).filter(Boolean);
    if (!normalizedSelectedValues.length) return variants.length === 1 ? variants[0] : null;

    return variants.find((variant) => {
      const normalizedVariantValues = new Set((variant.selectedValues || []).map(normalizeText));
      return normalizedSelectedValues.every((value) => normalizedVariantValues.has(value));
    }) || variants.find((variant) => {
      const normalizedVariantValues = (variant.selectedValues || []).map(normalizeText);
      const normalizedTitle = normalizeText(variant.title);

      return normalizedSelectedValues.every((value) => (
        normalizedTitle.includes(value)
        || normalizedVariantValues.some((variantValue) => variantValue.includes(value))
      ));
    }) || null;
  };

  const getModalQuantity = (modal) => {
    const label = modal.querySelector('.gbbProductQuantityLabel');
    const value = label ? Number(label.textContent.trim()) : 1;
    return Number.isFinite(value) && value > 0 ? Math.round(value) : 1;
  };

  const applyModalQuantityDomValue = (modal, quantity) => {
    const safeQuantity = Math.max(1, Math.round(quantity));
    const label = modal.querySelector('.gbbProductQuantityLabel');
    const input = modal.querySelector('.gbbProductQuantityInput, input[name="quantity"]');

    if (label && label.textContent.trim() !== String(safeQuantity)) {
      label.textContent = String(safeQuantity);
    }

    if (input && input.value !== String(safeQuantity)) {
      input.value = String(safeQuantity);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const clearModalQuantitySyncPending = (modal) => {
    delete modal.dataset.archiduchesseQuantitySyncPending;
    delete modal.dataset.archiduchesseQuantityTarget;
  };

  const setModalQuantitySyncPending = (modal, quantity) => {
    modal.dataset.archiduchesseQuantitySyncPending = 'true';
    modal.dataset.archiduchesseQuantityTarget = String(quantity);
  };

  const clickModalQuantityControl = (control) => {
    if (!control) return false;
    if (control.disabled || control.getAttribute('aria-disabled') === 'true') return false;
    control.click();
    return true;
  };

  const scheduleModalQuantitySyncRetry = (modal, quantity, attempt) => {
    if (attempt >= 4) return;

    window.setTimeout(() => {
      if (!document.documentElement.contains(modal)) return;

      setModalQuantity(modal, quantity, attempt + 1);
      syncProductModalStockState(modal);
    }, attempt === 0 ? 0 : 80);
  };

  const setModalQuantity = (modal, quantity, attempt = 0) => {
    if (!modal) return false;

    const safeQuantity = Math.max(1, Math.round(quantity));
    const currentQuantity = getModalQuantity(modal);

    if (currentQuantity === safeQuantity) {
      applyModalQuantityDomValue(modal, safeQuantity);
      clearModalQuantitySyncPending(modal);
      return true;
    }

    const controlSelector = currentQuantity > safeQuantity
      ? '.gbbProductQuantityRemoveButton'
      : '.gbbProductQuantityAddButton';
    const control = modal.querySelector(controlSelector);
    const controlClicks = Math.min(Math.abs(currentQuantity - safeQuantity), 20);
    let clickedControl = false;

    for (let index = 0; index < controlClicks; index += 1) {
      if (!clickModalQuantityControl(control)) break;
      clickedControl = true;
    }

    if (clickedControl) {
      if (getModalQuantity(modal) === safeQuantity) {
        clearModalQuantitySyncPending(modal);
        return true;
      }

      setModalQuantitySyncPending(modal, safeQuantity);
      scheduleModalQuantitySyncRetry(modal, safeQuantity, attempt);
      return false;
    }

    applyModalQuantityDomValue(modal, safeQuantity);
    clearModalQuantitySyncPending(modal);
    return getModalQuantity(modal) === safeQuantity;
  };

  const setControlDisabled = (control, isDisabled, label) => {
    if (!control) return;

    control.classList.toggle('gbbArchiduchesseDisabledForStock', isDisabled);
    control.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');

    if ('disabled' in control) {
      control.disabled = isDisabled;
    }

    if (label && normalizeText(control.textContent) !== normalizeText(label)) {
      control.textContent = label;
      control.setAttribute('aria-label', label);
    }
  };

  const getSelectedQuantityForVariant = (product, variantMeta) => {
    const productTitle = normalizeText(product && product.title);
    if (!productTitle) return 0;

    const selectedValues = (variantMeta && variantMeta.selectedValues ? variantMeta.selectedValues : [])
      .map(normalizeText)
      .filter(Boolean);
    const selectedItemSelectors = [
      '#gbbBundle .gbbSelectedProductItem',
      '#gbbBundle .gbbSelectedProductsContainer .gbbProductItem',
      '#gbbBundle .gbbBundleProductItem',
      '#gbbBundle .gbbBoxProductItem',
      '#gbbBundle .gbbCartProductItem'
    ];

    return selectedItemSelectors
      .flatMap((selector) => Array.from(document.querySelectorAll(selector)))
      .reduce((count, item) => {
        const text = normalizeText(item.textContent);
        if (!text.includes(productTitle)) return count;
        if (selectedValues.length && !selectedValues.some((value) => text.includes(value))) return count;

        const quantityMatch = String(item.textContent || '').match(/(?:x|×|quantit[eé]\s*:?)\s*(\d+)/i);
        const quantity = quantityMatch ? Number(quantityMatch[1]) : 1;
        return count + (Number.isFinite(quantity) && quantity > 0 ? quantity : 1);
      }, 0);
  };

  const getRemainingBundleSlots = () => {
    const targetCount = getRequiredPairCount();
    const selectedCount = getSelectedPairCount();
    return Math.max(0, targetCount - selectedCount);
  };

  const ensureModalStockNotice = (modal, message) => {
    const detailsContainer = modal.querySelector('.gbbProductVariantModalDetailsContainer');
    if (!detailsContainer) return;

    let notice = modal.querySelector('.gbbArchiduchesseStockNotice');
    if (!message) {
      if (notice) notice.remove();
      return;
    }

    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'gbbArchiduchesseStockNotice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');

      const actionContainer = detailsContainer.querySelector('.gbbProductCardActionContainer');
      if (actionContainer) detailsContainer.insertBefore(notice, actionContainer);
      else detailsContainer.appendChild(notice);
    }

    if (notice.textContent !== message) notice.textContent = message;
  };

  const getModalStockState = (modal) => {
    const product = findProductForModal(modal);
    const meta = getProductMeta(product);
    const variantMeta = findVariantMetaForSelectedValues(meta, getModalSelectedVariantValues(modal));
    const currentQuantity = getModalQuantity(modal);
    const stockQuantity = variantMeta && Number.isFinite(variantMeta.quantityAvailable)
      ? Math.max(0, variantMeta.quantityAvailable - getSelectedQuantityForVariant(product, variantMeta))
      : null;
    const remainingSlots = getRemainingBundleSlots();
    const limits = [remainingSlots];

    if (Number.isFinite(stockQuantity)) limits.push(stockQuantity);

    const quantityLimit = limits.length ? Math.max(0, Math.min(...limits)) : null;
    const isSoldOut = Boolean(
      (meta && meta.availability === 'sold-out')
      || (variantMeta && variantMeta.available === false)
      || (Number.isFinite(stockQuantity) && stockQuantity <= 0)
    );

    return {
      currentQuantity,
      isSoldOut,
      product,
      quantityLimit,
      remainingSlots,
      stockQuantity,
      variantMeta
    };
  };

  const syncModalVariantOptions = (modal, meta) => {
    Array.from(modal.querySelectorAll('.gbbProductVariantOptionValue')).forEach((option) => {
      const value = String(
        option.getAttribute('optionvalueid')
        || option.dataset.optionValue
        || option.dataset.value
        || option.dataset.archiduchesseRawValue
        || option.textContent
        || ''
      ).trim();
      const variantMeta = findVariantMetaForSelectedValues(meta, [value]);
      const isSoldOut = Boolean(variantMeta && variantMeta.available === false);
      const localizedSizeLabel = getLocalizedSizeLabel(value);

      option.dataset.archiduchesseRawValue = value;
      if (localizedSizeLabel && option.textContent !== localizedSizeLabel) {
        option.textContent = localizedSizeLabel;
        option.setAttribute('aria-label', localizedSizeLabel);
      }

      option.classList.toggle('gbbArchiduchesseVariantSoldOut', isSoldOut);
      option.setAttribute('aria-disabled', isSoldOut ? 'true' : 'false');
    });
  };

  const syncProductModalStockState = (modal = getModalContainer()) => {
    if (!modal) return;

    const product = findProductForModal(modal);
    const meta = getProductMeta(product);
    const state = getModalStockState(modal);
    const addButton = modal.querySelector('.gbbProductVariantAddButton');
    const plusButton = modal.querySelector('.gbbProductQuantityAddButton');
    const addLabel = state.isSoldOut
      ? soldOutLabel
      : state.quantityLimit === 0
        ? stockLimitLabel
        : modalAddButtonLabel;

    if (meta) syncModalVariantOptions(modal, meta);

    if (state.quantityLimit !== null && state.quantityLimit > 0 && state.currentQuantity > state.quantityLimit) {
      setModalQuantity(modal, state.quantityLimit);
      state.currentQuantity = getModalQuantity(modal);
    }

    const addDisabled = state.isSoldOut
      || state.quantityLimit === 0
      || (state.quantityLimit !== null && state.currentQuantity > state.quantityLimit);
    const plusDisabled = state.isSoldOut
      || state.quantityLimit === 0
      || (state.quantityLimit !== null && state.currentQuantity >= state.quantityLimit);

    modal.dataset.archiduchesseVariantAvailability = state.isSoldOut ? 'sold-out' : 'available';
    setControlDisabled(addButton, addDisabled, addLabel);
    setControlDisabled(plusButton, plusDisabled);

    if (state.isSoldOut) {
      ensureModalStockNotice(modal, t('sizeSoldOutNotice'));
    } else if (Number.isFinite(state.stockQuantity) && state.stockQuantity === 1) {
      ensureModalStockNotice(modal, t('onePairAvailableNotice'));
    } else if (state.remainingSlots === 1 && state.quantityLimit === 1) {
      ensureModalStockNotice(modal, t('oneSlotRemainingNotice'));
    } else {
      ensureModalStockNotice(modal, '');
    }
  };

  const syncProductCategories = () => {
    removeExcludedProductCards();

    const cards = Array.from(document.querySelectorAll(cardSelector));
    const productData = getBundleProducts();

    if (!productData.products || !productData.products.length) {
      if (categoryRetryCount < 20) {
        categoryRetryCount += 1;
        window.setTimeout(syncProductCategories, 500);
      }
      return;
    }

    categoryRetryCount = 0;
    const productByCard = buildCardProductMap(cards);

    cards.forEach((card, index) => {
      syncProductActionLabels(card);

      const title = card.querySelector('.gbbProductTitleOnly, .gbbProductItemTitle');
      if (!title) return;

      const product = findProductForCard(card, index, productByCard);
      const category = getCategoryFromProduct(product);
      let categoryElement = card.querySelector(`.${categoryClass}`);

      if (!category) {
        if (categoryElement) categoryElement.remove();
        return;
      }

      if (!categoryElement) {
        categoryElement = document.createElement('div');
        categoryElement.className = categoryClass;
        title.insertAdjacentElement('beforebegin', categoryElement);
      }

      if (categoryElement.textContent !== category) categoryElement.textContent = category;
      syncProductActionLabels(card);
    });
  };

  const syncProductModal = () => {
    const modal = getModalContainer();
    if (!modal) return;

    const addButton = modal.querySelector('.gbbProductVariantAddButton');
    if (addButton && normalizeText(addButton.textContent) !== normalizeText(modalAddButtonLabel)) {
      addButton.textContent = modalAddButtonLabel;
    }

    syncProductModalLabels(modal);
    translateNativeBundleTexts(modal);

    const detailsContainer = modal.querySelector('.gbbProductVariantModalDetailsContainer');
    const actionContainer = modal.querySelector('.gbbProductCardActionContainer');
    if (detailsContainer && actionContainer && actionContainer.parentElement !== detailsContainer) {
      detailsContainer.appendChild(actionContainer);
    }

    const title = modal.querySelector('.gbbProductItemTitle, .gbbProductTitleOnly');
    if (!title) return;

    const product = findProductForModal(modal);
    const category = getModalCategoryFromProduct(product);
    let categoryElement = modal.querySelector('.gbbArchiduchesseModalCategory');

    if (!category) {
      if (categoryElement) categoryElement.remove();
      syncProductModalStockState(modal);
      return;
    }

    if (!categoryElement) {
      categoryElement = document.createElement('div');
      categoryElement.className = 'gbbArchiduchesseModalCategory';
      title.insertAdjacentElement('beforebegin', categoryElement);
    }

    if (categoryElement.textContent !== category) categoryElement.textContent = category;
    syncProductModalStockState(modal);
  };

  const syncBundleIntro = () => {
    const wrapper = document.querySelector('#gbbBundle .gbbAddProductPageSubtextWrapper');
    const title = wrapper && wrapper.querySelector('.gbbAddProductPageSubtext');
    if (!wrapper || !title) return;

    if (isEnglishLocale) {
      const titleText = title.textContent || '';
      const titleCountMatch = titleText.match(/(\d+)/);
      const titleCount = titleCountMatch ? Number(titleCountMatch[1]) : bundleConfig.pairCount;
      const localizedTitle = `Choose your ${titleCount} products`;
      if (title.textContent !== localizedTitle) title.textContent = localizedTitle;
    }

    if (!wrapper.querySelector('.gbbArchiduchesseBundleIcon')) {
      const icon = document.createElement('span');
      icon.className = 'gbbArchiduchesseBundleIcon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = `<img src="${bundleIconUrl}" alt="" loading="eager" decoding="async">`;
      title.insertAdjacentElement('beforebegin', icon);
    }

    let description = wrapper.querySelector('.gbbArchiduchesseBundleDescription');
    if (!description) {
      description = document.createElement('p');
      description.className = 'gbbArchiduchesseBundleDescription';
      title.insertAdjacentElement('afterend', description);
    }

    const introText = bundleConfig.introDescription;
    if (description.textContent !== introText) description.textContent = introText;
  };

  const getProductKey = (product) => {
    if (!product) return '';
    return String(product.productId || product.id || product.handle || '').trim();
  };

  const getProductMeta = (product) => {
    const key = getProductKey(product);
    if (!key) return null;

    const cached = productMetaCache.get(key);
    if (cached && cached.status === 'error') retryProductMeta(product);
    return cached && cached.status === 'ready' ? cached.meta : null;
  };

  const extractSizeValue = (variant, productData) => {
    const productOptions = Array.isArray(productData && productData.options) ? productData.options : [];
    const sizeOptionIndex = productOptions.findIndex((option) => normalizeText(option.name).includes('taille'));

    if (sizeOptionIndex !== -1) {
      const value = variant[`option${sizeOptionIndex + 1}`];
      if (value) return String(value).trim();
    }

    const selectedOptions = Array.isArray(variant.selectedOptions)
      ? variant.selectedOptions
      : Array.isArray(variant.selected_options)
        ? variant.selected_options
        : [];
    const selectedSize = selectedOptions.find((option) => normalizeText(option.name).includes('taille'));

    if (selectedSize && selectedSize.value) return String(selectedSize.value).trim();

    const text = [variant.title, variant.option1, variant.option2, variant.option3]
      .filter(Boolean)
      .join(' ');
    const match = text.match(/\b\d{2}\s*[/|-]\s*\d{2}\b/);

    return match ? match[0].replace(/\s+/g, '') : '';
  };

  const getProductDataVariants = (productData) => {
    if (Array.isArray(productData && productData.variants)) return productData.variants;
    if (productData && productData.variants && Array.isArray(productData.variants.nodes)) {
      return productData.variants.nodes;
    }

    return [];
  };

  const getVariantAvailableQuantity = (variant) => {
    const quantity = Number(variant && (
      variant.quantityAvailable !== undefined ? variant.quantityAvailable : variant.inventory_quantity
    ));

    return Number.isFinite(quantity) ? quantity : null;
  };

  const getProductImageMeta = (productData) => {
    const featuredImage = productData && productData.featuredImage;
    if (featuredImage && featuredImage.url) {
      return {
        alt: featuredImage.altText || productData.title || '',
        url: featuredImage.url
      };
    }

    if (productData && productData.image && productData.image.src) {
      return {
        alt: productData.image.alt || productData.title || '',
        url: productData.image.src
      };
    }

    const images = Array.isArray(productData && productData.images) ? productData.images : [];
    const image = images.find((item) => item && (item.src || item.url));

    return image
      ? { alt: image.alt || productData.title || '', url: image.src || image.url }
      : { alt: productData && productData.title ? productData.title : '', url: '' };
  };

  const getProductPriceLabel = (productData, variants) => {
    const storefrontMoney = productData
      && productData.priceRange
      && productData.priceRange.minVariantPrice;
    const amount = storefrontMoney && Number(storefrontMoney.amount);
    const currencyCode = storefrontMoney && storefrontMoney.currencyCode;

    if (Number.isFinite(amount) && currencyCode) {
      try {
        return new Intl.NumberFormat('fr-FR', {
          currency: currencyCode,
          style: 'currency'
        }).format(amount);
      } catch (error) {
        return `${amount.toFixed(2)} ${currencyCode}`;
      }
    }

    const variant = Array.isArray(variants) ? variants[0] : null;
    const variantPrice = variant && Number(variant.price);
    if (Number.isFinite(variantPrice)) return `${variantPrice.toFixed(2)} €`;

    return '';
  };

  const isVariantAvailable = (variant) => {
    const quantity = getVariantAvailableQuantity(variant);

    if (variant && variant.availableForSale === false) return false;
    if (variant && variant.available === false) return false;
    if (variant && variant.currentlyNotInStock === true) return false;
    if (quantity !== null && quantity <= 0) return false;

    return true;
  };

  const buildProductMeta = (productData) => {
    const variants = getProductDataVariants(productData);
    const imageMeta = getProductImageMeta(productData);
    const variantMeta = variants.map((variant) => {
      const quantityAvailable = getVariantAvailableQuantity(variant);
      const size = extractSizeValue(variant, productData);

      return {
        available: isVariantAvailable(variant),
        id: String((variant && variant.id) || ''),
        numericId: getVariantNumericId(variant),
        quantityAvailable,
        selectedValues: getVariantSelectedValues(variant),
        size,
        title: String((variant && variant.title) || '')
      };
    });
    const availableVariantMeta = variantMeta.filter((variant) => variant.available);
    const sourceVariantMeta = availableVariantMeta.length ? availableVariantMeta : variantMeta;
    const sizes = new Set();
    const stockQuantities = availableVariantMeta
      .map((variant) => variant.quantityAvailable)
      .filter(Number.isFinite);
    const productAvailable = productData && productData.availableForSale !== false && productData.available !== false;
    const isAvailable = variants.length ? availableVariantMeta.length > 0 : productAvailable;

    sourceVariantMeta.forEach((variant) => {
      if (variant.size) sizes.add(variant.size);
    });

    return {
      availability: isAvailable ? 'available' : 'sold-out',
      availabilityLabel: isAvailable ? t('inStock') : t('unavailable'),
      handle: productData && productData.handle ? productData.handle : '',
      imageAlt: imageMeta.alt,
      imageUrl: imageMeta.url,
      maxAvailable: stockQuantities.length
        ? stockQuantities.reduce((total, quantity) => total + quantity, 0)
        : null,
      priceLabel: getProductPriceLabel(productData, variants),
      sizes: sortFilterOptions('size', sizes),
      title: productData && productData.title ? productData.title : '',
      variants: variantMeta
    };
  };

  const storefrontProductMetaQuery = `
    query ArchiduchesseBundleStock($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          title
          handle
          availableForSale
          totalInventory
          featuredImage {
            url
            altText
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          variants(first: 100) {
            nodes {
              id
              title
              availableForSale
              quantityAvailable
              currentlyNotInStock
              selectedOptions {
                name
                value
              }
            }
          }
        }
      }
    }
  `;

  const fetchStorefrontProductMeta = async (products) => {
    const token = getStorefrontAccessToken();
    if (!token || !Array.isArray(products) || !products.length) return false;

    const productsByGid = new Map();
    products.forEach((product) => {
      const gid = getProductGid(product);
      if (gid) productsByGid.set(gid, product);
    });

    let enrichedCount = 0;
    const productGids = Array.from(productsByGid.keys());

    const chunkNodes = await Promise.all(chunkArray(productGids, 35).map(async (ids) => {
      const response = await fetch(`/api/${storefrontApiVersion}/graphql.json`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({
          query: storefrontProductMetaQuery,
          variables: { ids }
        })
      });

      if (!response.ok) throw new Error('Storefront inventory unavailable');

      const payload = await response.json();
      if (Array.isArray(payload.errors) && payload.errors.length) {
        throw new Error('Storefront inventory unavailable');
      }

      const nodes = payload && payload.data && Array.isArray(payload.data.nodes)
        ? payload.data.nodes
        : [];

      return nodes;
    }));

    chunkNodes.flat().forEach((node) => {
        if (!node || !node.id) return;

        const product = productsByGid.get(node.id);
        const key = getProductKey(product) || getNumericId(node.id);

        if (key) {
          productMetaCache.set(key, { status: 'ready', meta: buildProductMeta(node) });
          enrichedCount += 1;
        }
      });

    return enrichedCount > 0;
  };

  const retryProductMeta = (product) => {
    const key = getProductKey(product);
    const gid = getProductGid(product);
    if (!key || !gid) return;

    const now = Date.now();
    const state = productMetaRetryState.get(key) || { attempts: 0, inFlight: false, lastAttemptAt: 0 };
    if (state.inFlight || state.attempts >= 2 || now - state.lastAttemptAt < 30000) return;

    state.inFlight = true;
    state.attempts += 1;
    state.lastAttemptAt = now;
    productMetaRetryState.set(key, state);

    fetchStorefrontProductMeta([product])
      .then(() => {
        syncCardFilterData();
        collectionControlsSignature = '';
        renderCollectionControls();
        renderCurrentProductPage({ force: true });
        syncProductModalStockState();
      })
      .catch(() => {})
      .finally(() => {
        state.inFlight = false;
        productMetaRetryState.set(key, state);
      });
  };

  const fetchCollectionProductMeta = async (products) => {
    const productsByHandle = new Map();
    const productsById = new Map();
    const getMissingProductCount = () => products.filter((product) => {
      const key = getProductKey(product);
      if (!key || productMetaCache.has(key)) return false;

      return !(
        (product.handle && productsByHandle.has(String(product.handle)))
        || productsById.has(String(product.productId || product.id))
      );
    }).length;

    for (let page = 1; page <= collectionProductJsonMaxPages && getMissingProductCount() > 0; page += 1) {
      const response = await fetch(`/collections/all/products.json?limit=${collectionProductJsonPageSize}&page=${page}`, {
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error('Collection product JSON unavailable');

      const data = await response.json();
      const collectionProducts = Array.isArray(data && data.products) ? data.products : [];

      collectionProducts.forEach((productData) => {
        if (productData.handle) productsByHandle.set(String(productData.handle), productData);
        if (productData.id) productsById.set(String(productData.id), productData);
      });

      if (collectionProducts.length < collectionProductJsonPageSize) break;
    }

    products.forEach((product) => {
      const key = getProductKey(product);
      if (!key || productMetaCache.has(key)) return;

      const productData = productsByHandle.get(String(product.handle))
        || productsById.get(String(product.productId || product.id));

      if (productData) {
        productMetaCache.set(key, { status: 'ready', meta: buildProductMeta(productData) });
      }
    });
  };

  const markMissingProductMeta = (products) => {
    products.forEach((product) => {
      const key = getProductKey(product);
      if (key && !productMetaCache.has(key)) {
        productMetaCache.set(key, { status: 'error', meta: null });
      }
    });
  };

  const getDynamicBundleCollectionNames = (productData) => {
    const tags = Array.isArray(productData && productData.tags) ? productData.tags : [];
    const names = tags
      .filter((tag) => normalizeText(tag).startsWith('chaussettes:'))
      .map((tag) => String(tag).split(':').slice(1).join(':').trim())
      .filter(Boolean)
      .map((value) => `Chaussettes ${value}`);

    if (names.length) return Array.from(new Set(names));

    const productType = String(productData && productData.product_type ? productData.product_type : '').trim();
    if (!productType) return ['Chaussettes'];
    if (normalizeText(productType).includes('lurex')) return ['Chaussettes paillettées'];
    if (normalizeText(productType).includes('de laine')) return ['Chaussettes cocooning'];

    return [`Chaussettes ${productType}`];
  };

  const hasDynamicBundleRecentSignal = (productData) => {
    const tags = Array.isArray(productData && productData.tags) ? productData.tags : [];
    const createdAt = String((productData && productData.created_at) || '').trim();

    return createdAt >= dynamicBundleRecentCreatedAt
      || tags.some((tag) => normalizeText(tag) === 'nouveautes');
  };

  const shouldIncludeDynamicBundleProduct = (productData) => {
    if (!productData || !productData.id || !productData.handle || !productData.title) return false;
    if (!hasDynamicBundleRecentSignal(productData)) return false;

    const productType = normalizeText(productData.product_type);
    const productText = normalizeText([
      productData.title,
      productData.handle,
      productData.product_type,
      Array.isArray(productData.tags) ? productData.tags.join(' ') : ''
    ].join(' '));

    if (productType === 'master') return false;
    if (productType.includes('chaussons')) return false;
    if (/semainier|coffret|duo|trio|pack|boite/.test(productText)) return false;

    return true;
  };

  const toDynamicBundleProduct = (productData) => ({
    id: productData.id,
    productId: productData.id,
    handle: productData.handle,
    title: productData.title,
    status: 'ACTIVE',
    tags: Array.isArray(productData.tags) ? productData.tags : [],
    collectionIds: [],
    collectionNames: getDynamicBundleCollectionNames(productData),
    sellingPlanGroups: [],
    updatedAt: productData.updated_at || null
  });

  const fetchDynamicBundleCollectionProducts = async () => {
    const products = [];

    for (let page = 1; page <= dynamicBundleProductJsonMaxPages; page += 1) {
      const response = await fetch(`/collections/${dynamicBundleCollectionHandle}/products.json?limit=${dynamicBundleProductJsonPageSize}&page=${page}`, {
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error('Dynamic bundle collection unavailable');

      const data = await response.json();
      const pageProducts = Array.isArray(data && data.products) ? data.products : [];
      products.push(...pageProducts);

      if (pageProducts.length < dynamicBundleProductJsonPageSize) break;
    }

    return products;
  };

  const enrichBundleProductsFromDynamicCollection = async () => {
    const rawProducts = getRawBundleProducts();
    if (!Array.isArray(rawProducts)) return 0;

    const knownProductIds = new Set(rawProducts
      .map((product) => String(product.productId || product.id || ''))
      .filter(Boolean));
    const knownProductHandles = new Set(rawProducts
      .map((product) => normalizeText(product.handle))
      .filter(Boolean));

    const products = await fetchDynamicBundleCollectionProducts();
    const productsToAdd = products
      .filter(shouldIncludeDynamicBundleProduct)
      .map((productData) => ({
        product: toDynamicBundleProduct(productData),
        source: productData
      }))
      .filter(({ product }) => (
        !knownProductIds.has(String(product.productId || product.id))
        && !knownProductHandles.has(normalizeText(product.handle))
        && !isExcludedProduct(product)
      ))
      .sort((a, b) => String(b.source.created_at || '').localeCompare(String(a.source.created_at || '')));

    productsToAdd.slice().reverse().forEach(({ product, source }) => {
      rawProducts.unshift(product);
      knownProductIds.add(String(product.productId || product.id));
      knownProductHandles.add(normalizeText(product.handle));

      const key = getProductKey(product);
      if (key) productMetaCache.set(key, { status: 'ready', meta: buildProductMeta(source) });
    });

    if (!productsToAdd.length) return 0;

    bundleProductCache = null;
    currentProductPage = 1;
    collectionControlsSignature = '';
    collectionPageRenderSignature = '';
    syncCardFilterData();
    renderCollectionControls();
    renderCurrentProductPage({ force: true });
    updateProductCount();

    return productsToAdd.length;
  };

  const scheduleProductMetaEnrichment = () => {
    if (productMetaStarted) return;

    productMetaStarted = true;

    const runProductMetaEnrichment = (products) => {
      (async () => {
        try {
          const enrichedFromStorefront = await fetchStorefrontProductMeta(products);
          const hasMissingMeta = products.some((product) => !productMetaCache.has(getProductKey(product)));

          if (!enrichedFromStorefront || hasMissingMeta) {
            await fetchCollectionProductMeta(products);
          }
        } catch (error) {
          try {
            await fetchCollectionProductMeta(products);
          } catch (fallbackError) {
            markMissingProductMeta(products);
          }
        } finally {
          markMissingProductMeta(products);
          productMetaFinished = true;
          syncCardFilterData();
          collectionControlsSignature = '';
          renderCollectionControls();
          renderCurrentProductPage({ force: true });
        }
      })();
    };

    const startWhenProductsReady = (attempt = 0) => {
      const products = getAllBundleProducts();
      if (products.length) {
        runProductMetaEnrichment(products);
        return;
      }

      if (attempt >= 20) {
        productMetaFinished = true;
        return;
      }

      window.setTimeout(() => startWhenProductsReady(attempt + 1), 500);
    };

    startWhenProductsReady();
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));

  const getFilterValues = (groupKey) => selectedFilters[groupKey] || new Set();

  const getActiveFilterEntries = () => filterGroupConfig.flatMap((group) => (
    Array.from(getFilterValues(group.key)).map((value) => ({
      displayValue: group.key === 'size' ? getLocalizedSizeLabel(value) : value,
      key: group.key,
      label: group.label,
      value
    }))
  ));

  const addFilterOption = (options, key, value) => {
    if (!value) return;
    options[key].set(value, (options[key].get(value) || 0) + 1);
  };

  const getFilterOptions = () => {
    const productData = getBundleProducts();
    const products = Array.isArray(productData.products) ? productData.products : [];
    const options = filterGroupConfig.reduce((memo, group) => {
      memo[group.key] = new Map();
      return memo;
    }, {});

    products.forEach((product) => {
      const category = getCategoryFromProduct(product);
      const color = getProductColor(product);
      const meta = getProductMeta(product);

      addFilterOption(options, 'type', category);
      addFilterOption(options, 'color', color);

      if (meta) {
        meta.sizes.forEach((size) => addFilterOption(options, 'size', size));
        addFilterOption(options, 'availability', meta.availabilityLabel);
      }
    });

    return options;
  };

  const getFilterOptionEntries = (groupKey, optionMap) => (
    sortFilterOptions(groupKey, optionMap.keys()).map((value) => ({
      value,
      label: groupKey === 'size' ? getLocalizedSizeLabel(value) : value,
      count: optionMap.get(value) || 0
    }))
  );

  const productMatchesSelectedFilters = (product) => {
    const typeValues = getFilterValues('type');
    if (typeValues.size && !typeValues.has(getCategoryFromProduct(product))) return false;

    const colorValues = getFilterValues('color');
    if (colorValues.size && !colorValues.has(getProductColor(product))) return false;

    const meta = getProductMeta(product);
    const availabilityValues = getFilterValues('availability');
    if (availabilityValues.size && (!meta || !availabilityValues.has(meta.availabilityLabel))) return false;

    const sizeValues = getFilterValues('size');
    if (sizeValues.size) {
      if (!meta) return false;
      const comparableSizes = new Set(meta.sizes.map(getComparableValue));
      if (!Array.from(sizeValues).some((size) => comparableSizes.has(getComparableValue(size)))) {
        return false;
      }
    }

    return true;
  };

  const getAllBundleProducts = () => {
    const productData = getBundleProducts();
    return Array.isArray(productData.products) ? productData.products : [];
  };

  const getFilteredProducts = () => getAllBundleProducts().filter(productMatchesSelectedFilters);

  const getPaginationPageCount = (filteredProducts) => (
    Math.max(1, Math.ceil(filteredProducts.length / productsPerPage))
  );

  const clampProductPage = (page, filteredProducts) => {
    const pageCount = getPaginationPageCount(filteredProducts);
    const parsedPage = Number(page);
    if (!Number.isFinite(parsedPage)) return 1;
    return Math.min(pageCount, Math.max(1, Math.round(parsedPage)));
  };

  const getVisiblePageProducts = (filteredProducts) => {
    currentProductPage = clampProductPage(currentProductPage, filteredProducts);
    const start = (currentProductPage - 1) * productsPerPage;
    return filteredProducts.slice(start, start + productsPerPage);
  };

  const getCollectionRenderApi = () => {
    const runtime = getEasyBundleRuntime();
    const addProductsPage = runtime && runtime.gbbAddProductsPage;
    const renderProductsCardContainer = addProductsPage
      && addProductsPage.f
      && addProductsPage.f.renderProductsCardContainer;

    if (typeof renderProductsCardContainer !== 'function') return null;

    return {
      renderProductsCardContainer,
      noteAttribute: (runtime.state && runtime.state.currentPageId) || 'addProductsPage1',
      categoryId: runtime.gbbMultipleCategoriesPage
        && runtime.gbbMultipleCategoriesPage.state
        && runtime.gbbMultipleCategoriesPage.state.currentCategoryId
    };
  };

  const getFilterLoadingLabel = () => {
    if (!getAllBundleProducts().length) return t('loadingProducts');
    if (!productMetaFinished) return t('loadingSizes');
    return '';
  };

  const hideNativeBundleFilters = () => {
    document.querySelectorAll(
      '#gbbBundle .gbbFiltersSearchSortHeader, #gbbBundle .gbbFiltersMainButtonWrapper, #gbbBundle .gbbFiltersDropDownButton'
    ).forEach((node) => {
      node.setAttribute('hidden', '');
      node.setAttribute('aria-hidden', 'true');
    });
  };

  const applyCollectionFacetsOpenState = (controls) => {
    const disclosure = controls.querySelector('.mobile-facets__disclosure');
    const openButton = controls.querySelector('.ac-filters-btn');

    if (disclosure) {
      disclosure.setAttribute('open', '');
      disclosure.open = true;
      disclosure.classList.add('menu-opening');
    }

    if (openButton) openButton.setAttribute('aria-expanded', 'true');
    document.documentElement.setAttribute('data-archiduchesse-filters-open', 'true');
    document.body.classList.add('overflow-hidden-mobile');
  };

  const ensureCollectionControls = () => {
    const bundle = document.querySelector('#gbbBundle');
    if (!bundle) return null;

    hideNativeBundleFilters();
    bundle.querySelectorAll('.gbbArchiduchesseFilters').forEach((node) => node.remove());

    let controls = bundle.querySelector('.gbbArchiduchesseCollectionControls');
    if (controls) return controls;

    const insertionTarget = bundle.querySelector('.gbbProductsContainer')
      || bundle.querySelector('.gbbProductsItemsContainer');
    if (!insertionTarget || !insertionTarget.parentElement) return null;

    controls = document.createElement('div');
    controls.className = 'gbbArchiduchesseCollectionControls ac-facets-wrap';
    controls.innerHTML = `
      <div class="ac-filterbar">
        <div class="ac-filterbar__left">
          <span class="ac-filterbar__count" aria-live="polite"></span>
          <div class="ac-filterbar__active-filters"></div>
        </div>
        <div class="ac-filterbar__right">
          <button class="ac-filters-btn" type="button" aria-controls="${filterDrawerId}" aria-expanded="false">${t('filters')}</button>
        </div>
      </div>
      <details class="mobile-facets__disclosure gbbArchiduchesseFilterDisclosure">
        <summary class="mobile-facets__open-wrapper focus-offset" aria-hidden="true" tabindex="-1"></summary>
        <div class="mobile-facets__wrapper gbbArchiduchesseCollectionFacetsWrapper">
          <button class="gbbArchiduchesseFacetOverlay" type="button" aria-label="${t('closeFilters')}"></button>
          <div id="${filterDrawerId}" class="mobile-facets gbbArchiduchesseCollectionFilterDrawer" role="dialog" aria-modal="true" aria-label="${t('filterProductAria')}">
            <div class="mobile-facets__inner gradient">
              <div class="mobile-facets__header">
                <div class="mobile-facets__header-inner">
                  <p class="mobile-facets__heading">${t('filterHeading')}</p>
                  <p class="mobile-facets__count" aria-live="polite"></p>
                </div>
                <button class="mobile-facets__close" type="button" aria-label="${t('closeFilters')}">×</button>
              </div>
              <div class="mobile-facets__main has-submenu gradient"></div>
              <div class="mobile-facets__footer gradient">
                <div class="active-facets-mobile"></div>
                <button class="active-facets__button-remove-all gbbArchiduchesseClearFilters" type="button">${t('clearFilters')}</button>
                <button class="mobile-facets__submit button button--primary gbbArchiduchesseApplyFilters" type="button">${t('applyFilters')}</button>
              </div>
            </div>
          </div>
        </div>
      </details>
    `;

    insertionTarget.parentElement.insertBefore(controls, insertionTarget);
    return controls;
  };

  const renderActiveFilters = (container, activeFilters) => {
    if (!container) return;

    container.innerHTML = '';
    activeFilters.forEach((entry) => {
      const pill = document.createElement('button');
      pill.type = 'button';
      pill.className = container.classList.contains('active-facets-mobile')
        ? 'facets-pill'
        : 'ac-active-pill';
      pill.dataset.filterGroup = entry.key;
      pill.dataset.filterValue = entry.value;
      pill.innerHTML = `${escapeHtml(entry.displayValue || entry.value)} <span class="ac-active-pill__x" aria-hidden="true">×</span>`;
      pill.setAttribute('aria-label', `${t('removeFilter')} ${entry.displayValue || entry.value}`);
      container.appendChild(pill);
    });
  };

  const renderCollectionControls = () => {
    const controls = ensureCollectionControls();
    if (!controls) return;

    const allProducts = getAllBundleProducts();
    const filteredProducts = getFilteredProducts();
    const activeFilters = getActiveFilterEntries();
    const options = getFilterOptions();
    const loadingLabel = getFilterLoadingLabel();
    const optionsSignature = filterGroupConfig.reduce((memo, group) => {
      memo[group.key] = getFilterOptionEntries(group.key, options[group.key]);
      return memo;
    }, {});
    const signature = JSON.stringify({
      activeFilters,
      count: filteredProducts.length,
      total: allProducts.length,
      productMetaFinished,
      options: optionsSignature,
      currentProductPage
    });

    if (collectionControlsSignature === signature) return;
    collectionControlsSignature = signature;

    const productLabel = filteredProducts.length === 1 ? t('productSingular') : t('productPlural');
    const countText = `${filteredProducts.length} ${productLabel}${activeFilters.length ? t('filteredSuffix') : ''}`;
    const countElement = controls.querySelector('.ac-filterbar__count');
    if (countElement) countElement.textContent = loadingLabel && !allProducts.length ? loadingLabel : countText;

    renderActiveFilters(controls.querySelector('.ac-filterbar__active-filters'), activeFilters);
    renderActiveFilters(controls.querySelector('.active-facets-mobile'), activeFilters);

    const openButton = controls.querySelector('.ac-filters-btn');
    if (openButton) {
      openButton.textContent = `${t('filters')}${activeFilters.length ? ` (${activeFilters.length})` : ''}`;
      openButton.disabled = !allProducts.length;
      openButton.setAttribute('aria-disabled', allProducts.length ? 'false' : 'true');
    }

    const drawerCount = controls.querySelector('.mobile-facets__count');
    if (drawerCount) drawerCount.textContent = loadingLabel || countText.replace(' :', '');

    const clearButton = controls.querySelector('.gbbArchiduchesseClearFilters');
    if (clearButton) clearButton.hidden = false;

    const main = controls.querySelector('.mobile-facets__main');
    if (!main) return;

    main.innerHTML = '';
    filterGroupConfig.forEach((group) => {
      const entries = getFilterOptionEntries(group.key, options[group.key]);
      const selectedValues = getFilterValues(group.key);
      const details = document.createElement('details');
      details.className = 'mobile-facets__details js-filter';
      details.dataset.filterGroup = group.key;
      details.innerHTML = `
        <summary class="mobile-facets__summary focus-inset">
          <div>
            <span>${escapeHtml(group.label)}</span>
            <span class="mobile-facets__arrow" aria-hidden="true">→</span>
          </div>
        </summary>
        <div class="mobile-facets__submenu gradient">
          <button class="mobile-facets__close-button link link--text focus-inset" type="button">
            <span aria-hidden="true">‹</span>
            ${escapeHtml(group.label)}
          </button>
          <ul class="mobile-facets__list list-unstyled" role="list"></ul>
        </div>
      `;

      const list = details.querySelector('.mobile-facets__list');
      if (!entries.length) {
        const item = document.createElement('li');
        item.className = 'mobile-facets__item list-menu__item';
        item.innerHTML = `<span class="gbbArchiduchesseFilterEmpty">${escapeHtml(loadingLabel || t('emptyFilterOption'))}</span>`;
        list.appendChild(item);
      } else {
        entries.forEach((entry) => {
          const id = `gbb-${group.key}-${getComparableValue(entry.value)}`;
          const item = document.createElement('li');
          item.className = 'mobile-facets__item list-menu__item';
          item.innerHTML = `
            <label class="facets__label mobile-facets__label">
              <input
                id="${escapeHtml(id)}"
                class="mobile-facets__checkbox gbbArchiduchesseFilterCheckbox"
                type="checkbox"
                data-filter-group="${escapeHtml(group.key)}"
                data-filter-value="${escapeHtml(entry.value)}"
                ${selectedValues.has(entry.value) ? 'checked' : ''}
              >
              <span class="mobile-facets__highlight"></span>
              <span>${escapeHtml(entry.label)}</span>
              <span class="facets__item-count">(${entry.count})</span>
            </label>
          `;
          list.appendChild(item);
        });
      }

      main.appendChild(details);
    });
  };

  const openCollectionFacets = () => {
    const controls = ensureCollectionControls();
    if (!controls || !getAllBundleProducts().length) return;

    applyCollectionFacetsOpenState(controls);
  };

  const closeFilterSubgroup = (details) => {
    if (!(details instanceof HTMLDetailsElement)) return;

    details.classList.remove('menu-opening');
    details.open = false;
    details.removeAttribute('open');
  };

  const closeCollectionFacets = () => {
    const controls = document.querySelector('#gbbBundle .gbbArchiduchesseCollectionControls');
    if (!controls) return;

    const disclosure = controls.querySelector('.mobile-facets__disclosure');
    const openButton = controls.querySelector('.ac-filters-btn');

    controls.querySelectorAll('.mobile-facets__details.js-filter').forEach(closeFilterSubgroup);

    if (disclosure) {
      disclosure.open = false;
      disclosure.removeAttribute('open');
      disclosure.classList.remove('menu-opening');
    }

    if (openButton) openButton.setAttribute('aria-expanded', 'false');
    document.documentElement.removeAttribute('data-archiduchesse-filters-open');
    document.body.classList.remove('overflow-hidden-mobile');
  };

  const syncFilterSubgroupState = (details) => {
    if (!(details instanceof HTMLDetailsElement)) return;

    window.setTimeout(() => {
      if (details.open) details.classList.add('menu-opening');
      else details.classList.remove('menu-opening');
    }, 0);
  };

  const resetCollectionPageAndRender = () => {
    currentProductPage = 1;
    collectionControlsSignature = '';
    renderCollectionControls();
    renderCurrentProductPage({ force: true });
  };

  const renderCollectionPagination = (filteredProducts) => {
    const productContainer = document.querySelector('#gbbBundle .gbbProductsContainer');
    if (!productContainer || !productContainer.parentElement) return;

    let wrapper = document.querySelector('#gbbBundle .gbbArchiduchessePagination');
    const pageCount = getPaginationPageCount(filteredProducts);
    if (pageCount <= 1) {
      if (wrapper) wrapper.remove();
      return;
    }

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'pagination-wrapper gbbArchiduchessePagination';
      productContainer.insertAdjacentElement('afterend', wrapper);
    }

    const pageItems = [];
    if (currentProductPage > 1) {
      pageItems.push(`<li><button type="button" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" data-page="${currentProductPage - 1}" aria-label="${t('carouselPreviousPage')}">‹</button></li>`);
    }

    for (let page = 1; page <= pageCount; page += 1) {
      const current = page === currentProductPage;
      pageItems.push(`
        <li>
          <button
            type="button"
            class="pagination__item${current ? ' pagination__item--current light' : ' link'}"
            data-page="${page}"
            ${current ? 'aria-current="page" aria-disabled="true"' : ''}
            aria-label="Page ${page}"
          >${page}</button>
        </li>
      `);
    }

    if (currentProductPage < pageCount) {
      pageItems.push(`<li><button type="button" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" data-page="${currentProductPage + 1}" aria-label="${t('carouselNextPage')}">›</button></li>`);
    }

    wrapper.dataset.page = String(currentProductPage);
    wrapper.innerHTML = `
      <nav class="pagination" role="navigation" aria-label="Pagination">
        <ul class="pagination__list list-unstyled" role="list">${pageItems.join('')}</ul>
      </nav>
    `;
  };

  const hasRenderedProductCard = (container, product) => {
    const key = getProductKey(product);
    const title = normalizeText(product && product.title);

    return Array.from(container.querySelectorAll('.gbbProductItem')).some((card) => (
      (key && card.dataset.archiduchesseProductKey === key)
      || (title && normalizeText(getTitle(card)) === title)
    ));
  };

  const createSyntheticSoldOutCard = (product) => {
    const meta = getProductMeta(product);
    const card = document.createElement('div');
    const category = getCategoryFromProduct(product);
    const title = product && product.title ? product.title : meta && meta.title ? meta.title : '';
    const imageHtml = meta && meta.imageUrl
      ? `<img class="gbbProductImageContainerImg" src="${escapeHtml(meta.imageUrl)}" alt="${escapeHtml(meta.imageAlt || title)}" loading="lazy" decoding="async">`
      : '';
    const priceHtml = meta && meta.priceLabel
      ? `<div class="gbbProductItemPricesContainer"><span class="gbbProductItemPrice">${escapeHtml(meta.priceLabel)}</span></div>`
      : '';

    card.className = 'gbbProductItem gbbArchiduchesseSoldOut gbbArchiduchesseSyntheticSoldOutCard';
    card.dataset.archiduchesseProductKey = getProductKey(product);
    card.dataset.archiduchesseFilterType = category;
    card.dataset.archiduchesseFilterColor = getProductColor(product);
    card.dataset.archiduchesseFilterAvailability = meta && meta.availabilityLabel ? meta.availabilityLabel : '';
    card.dataset.archiduchesseFilterSize = meta && Array.isArray(meta.sizes)
      ? meta.sizes.map(getComparableValue).join('|')
      : '';
    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-disabled', 'true');
    card.setAttribute('aria-label', `${title} - ${soldOutLabel}`);
    card.innerHTML = `
      <div class="gbbProductImageContainer">
        ${imageHtml}
        <span class="gbbArchiduchesseSoldOutBadge" aria-hidden="true">${soldOutLabel}</span>
      </div>
      <div class="gbbProductTextContainer">
        ${category ? `<div class="${categoryClass}">${escapeHtml(category)}</div>` : ''}
        <div class="gbbProductItemTitle">${escapeHtml(title)}</div>
      </div>
      <div class="gbbProductActionContainer">${priceHtml}</div>
    `;

    syncCardSoldOutState(card, meta);
    return card;
  };

  const renderMissingSoldOutCards = (pageProducts) => {
    const container = document.querySelector('#gbbBundle .gbbProductsItemsContainer');
    if (!container) return;

    const expectedKeys = new Set(pageProducts
      .filter((product) => {
        const meta = getProductMeta(product);
        return Boolean(meta && meta.availability === 'sold-out');
      })
      .map(getProductKey)
      .filter(Boolean));

    container.querySelectorAll('.gbbArchiduchesseSyntheticSoldOutCard').forEach((card) => {
      const key = card.dataset.archiduchesseProductKey;
      if (!key || !expectedKeys.has(key)) card.remove();
    });

    pageProducts.forEach((product) => {
      const meta = getProductMeta(product);
      if (!meta || meta.availability !== 'sold-out') return;
      if (hasRenderedProductCard(container, product)) return;

      container.appendChild(createSyntheticSoldOutCard(product));
    });
  };

  const renderCurrentProductPage = ({ force = false } = {}) => {
    const filteredProducts = getFilteredProducts();
    const pageProducts = getVisiblePageProducts(filteredProducts);
    renderCollectionPagination(filteredProducts);

    const signature = JSON.stringify({
      page: currentProductPage,
      keys: pageProducts.map((product) => getProductKey(product) || product.handle || product.title),
      filters: getActiveFilterEntries(),
      meta: productMetaFinished
    });

    if (!force && collectionPageRenderSignature === signature && getProductCount() === pageProducts.length) {
      return true;
    }

    const api = getCollectionRenderApi();
    if (!api) {
      if (scheduledCollectionRenderTimer) window.clearTimeout(scheduledCollectionRenderTimer);
      if (collectionRenderRetryCount < 80) {
        collectionRenderRetryCount += 1;
        scheduledCollectionRenderTimer = window.setTimeout(() => {
          renderCurrentProductPage({ force });
        }, 250);
      }
      return false;
    }

    collectionRenderRetryCount = 0;
    collectionPageRenderSignature = signature;
    isRenderingCollectionPage = true;

    Promise.resolve(
      api.renderProductsCardContainer(
        pageProducts,
        api.noteAttribute,
        'resetProductCardsContainer',
        api.categoryId
      )
      )
      .then(() => {
        removeExcludedProductCards();
        renderMissingSoldOutCards(pageProducts);
        enhanceCards();
        syncProductCategories();
        syncCardFilterData();
        decorateLoadMoreButton();
        updateProductCount();
        updateBundleFooter();
      })
      .catch(() => {
        collectionPageRenderSignature = '';
      })
      .finally(() => {
        window.setTimeout(() => {
          isRenderingCollectionPage = false;
          renderCollectionPagination(getFilteredProducts());
        }, 0);
      });

    return true;
  };

  const syncCardSoldOutState = (card, meta) => {
    const isSoldOut = Boolean(meta && meta.availability === 'sold-out');
    let badge = card.querySelector('.gbbArchiduchesseSoldOutBadge');

    card.classList.toggle('gbbArchiduchesseSoldOut', isSoldOut);
    card.dataset.archiduchesseAvailability = meta && meta.availability ? meta.availability : '';
    card.setAttribute('aria-disabled', isSoldOut ? 'true' : 'false');

    const title = getTitle(card);
    if (title) {
      card.setAttribute('aria-label', isSoldOut ? `${title} - ${soldOutLabel}` : `${t('chooseProduct')} ${title}`);
    }

    if (Number.isFinite(meta && meta.maxAvailable)) {
      card.dataset.archiduchesseMaxAvailable = String(meta.maxAvailable);
    } else {
      delete card.dataset.archiduchesseMaxAvailable;
    }

    if (!isSoldOut) {
      if (badge) badge.remove();
      return;
    }

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'gbbArchiduchesseSoldOutBadge';
      badge.setAttribute('aria-hidden', 'true');

      const imageContainer = card.querySelector('.gbbProductImageContainer');
      if (imageContainer) imageContainer.appendChild(badge);
      else card.insertAdjacentElement('afterbegin', badge);
    }

    if (badge.textContent !== soldOutLabel) badge.textContent = soldOutLabel;
  };

  const isSoldOutCard = (card) => (
    Boolean(card && card.dataset.archiduchesseAvailability === 'sold-out')
  );

  const isStockPendingCard = (card) => (
    Boolean(card && productMetaStarted && !productMetaFinished && !card.dataset.archiduchesseAvailability)
  );

  const syncCardFilterData = () => {
    const cards = Array.from(document.querySelectorAll(cardSelector));
    const productByCard = buildCardProductMap(cards);

    cards.forEach((card, index) => {
      const product = findProductForCard(card, index, productByCard);
      const meta = getProductMeta(product);
      const key = getProductKey(product);

      if (key) card.dataset.archiduchesseProductKey = key;
      card.dataset.archiduchesseFilterType = getCategoryFromProduct(product);
      card.dataset.archiduchesseFilterColor = getProductColor(product);

      if (meta) {
        card.dataset.archiduchesseFilterSize = meta.sizes.map(getComparableValue).join('|');
        card.dataset.archiduchesseFilterAvailability = meta.availabilityLabel || '';
      } else {
        delete card.dataset.archiduchesseFilterSize;
        delete card.dataset.archiduchesseFilterAvailability;
      }

      syncProductActionLabels(card);
      syncCardSoldOutState(card, meta);
    });
  };

  const getMutationElement = (mutation) => {
    if (mutation.target instanceof Element) return mutation.target;
    return mutation.target && mutation.target.parentElement
      ? mutation.target.parentElement
      : null;
  };

  const shouldIgnoreMutation = (mutation) => {
    const target = getMutationElement(mutation);
    return Boolean(target && target.closest('.gbbArchiduchesseCollectionControls, .gbbArchiduchessePagination'));
  };

  const isRelevantMutationElement = (element) => {
    if (!(element instanceof Element)) return false;

    return Boolean(
      element.matches(mutationRelevantSelector)
      || element.closest(mutationRelevantSelector)
      || element.querySelector(mutationRelevantSelector)
    );
  };

  const isRelevantMutation = (mutation) => {
    const target = getMutationElement(mutation);
    if (isRelevantMutationElement(target)) return true;

    return Array.from(mutation.addedNodes).some(isRelevantMutationElement)
      || Array.from(mutation.removedNodes).some(isRelevantMutationElement);
  };

  const syncBundleDom = () => {
    scheduledDomSync = false;

    const roots = scheduledDomSyncEnhanceRoots;
    scheduledDomSyncPreviousProductCount = null;
    scheduledDomSyncEnhanceRoots = [];

    roots.forEach((node) => {
      if (node instanceof Element) enhanceCards(node);
    });

    removeExcludedProductCards();
    syncProductCategories();
    syncCardFilterData();
    renderCollectionControls();
    if (!isRenderingCollectionPage) renderCurrentProductPage();
    syncProductModal();
    syncProductModalLabels();
    syncBundleIntro();
    translateNativeBundleTexts();
    syncLocalizedSizeLabels();
    syncProductActionLabels();
    syncLoadingNotice();
    decorateLoadMoreButton();
    decorateProductModalAccessibility();
    disableReviewStep();
    suppressPreparingBundleModal();
    updateProductCount();
    updateBundleFooter();
    translateNativeBundleTexts();
    syncLocalizedSizeLabels();
    syncProductActionLabels();
    scheduleNativeBundleTextTranslation();
    maybeSubmitReviewPage();
  };

  const scheduleDomSync = (mutations) => {
    const relevantMutations = mutations.filter((mutation) => (
      isRelevantMutation(mutation) && !shouldIgnoreMutation(mutation)
    ));

    if (!relevantMutations.length) return;

    if (scheduledDomSyncPreviousProductCount === null) {
      scheduledDomSyncPreviousProductCount = getProductCount();
    }

    relevantMutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element && scheduledDomSyncEnhanceRoots.length < 30) {
          scheduledDomSyncEnhanceRoots.push(node);
        }
      });
    });

    if (scheduledDomSync) return;

    scheduledDomSync = true;
    const schedule = window.requestAnimationFrame || ((callback) => window.setTimeout(callback, 50));
    schedule(syncBundleDom);
  };

  const handleCollectionControlsClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const controls = event.target.closest('#gbbBundle .gbbArchiduchesseCollectionControls, #gbbBundle .gbbArchiduchessePagination');
    if (!controls) return;

    const filterSummary = event.target.closest('.mobile-facets__details.js-filter > summary.mobile-facets__summary');
    if (filterSummary && filterSummary.parentElement instanceof HTMLDetailsElement) {
      syncFilterSubgroupState(filterSummary.parentElement);
      return;
    }

    const openButton = event.target.closest('.ac-filters-btn');
    const submenuBackButton = event.target.closest('.mobile-facets__close-button');
    const closeDrawerButton = event.target.closest('.mobile-facets__close, .gbbArchiduchesseFacetOverlay, .gbbArchiduchesseApplyFilters');
    const pill = event.target.closest('.ac-active-pill, .facets-pill');
    const clearButton = event.target.closest('.ac-clear-all, .gbbArchiduchesseClearFilters');
    const pageButton = event.target.closest('.pagination__item[data-page]');

    if (openButton) {
      event.preventDefault();
      openCollectionFacets();
      return;
    }

    if (submenuBackButton) {
      event.preventDefault();
      closeFilterSubgroup(submenuBackButton.closest('.mobile-facets__details.js-filter'));
      return;
    }

    if (closeDrawerButton) {
      event.preventDefault();
      closeCollectionFacets();
      return;
    }

    if (pill) {
      event.preventDefault();
      const group = pill.dataset.filterGroup;
      const value = pill.dataset.filterValue;
      if (group && value) getFilterValues(group).delete(value);
      resetCollectionPageAndRender();
      return;
    }

    if (clearButton) {
      event.preventDefault();
      Object.values(selectedFilters).forEach((values) => values.clear());
      resetCollectionPageAndRender();
      return;
    }

    if (pageButton) {
      event.preventDefault();
      currentProductPage = Number(pageButton.dataset.page) || 1;
      collectionControlsSignature = '';
      renderCollectionControls();
      renderCurrentProductPage({ force: true });
      const productContainer = document.querySelector('#gbbBundle .gbbProductsContainer');
      if (productContainer) productContainer.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  };

  const handleCollectionControlsChange = (event) => {
    if (!(event.target instanceof Element)) return;

    const input = event.target.closest('#gbbBundle .gbbArchiduchesseFilterCheckbox');
    if (!input) return;

    const group = input.dataset.filterGroup;
    const value = input.dataset.filterValue;
    if (!group || !value) return;

    const values = getFilterValues(group);
    if (input.checked) values.add(value);
    else values.delete(value);
    resetCollectionPageAndRender();
  };

  const blockModalStockEvent = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    window.setTimeout(() => syncProductModalStockState(), 0);
  };

  const getLocalizedNativeText = (text) => {
    if (!isEnglishLocale) return text;

    const value = String(text || '').trim();
    const chooseHeading = value.match(/^Choisissez vos\s+(\d+)\s+produits$/i);
    if (chooseHeading) return `Choose your ${chooseHeading[1]} products`;

    const productCount = value.match(/^(\d+)\s+produits?$/i);
    if (productCount) {
      const count = Number(productCount[1]);
      return `${count} ${count === 1 ? t('productSingular') : t('productPlural')}`;
    }

    const addDiscount = value.match(/^Ajouter\s+(\d+)\s+produit(?:\(s\))?\s+pour\s+obtenir\s+0%\s*!?$/i);
    if (addDiscount) {
      const count = Number(addDiscount[1]);
      return `Add ${count} ${count === 1 ? t('productSingular') : t('productPlural')} to complete your gift box.`;
    }

    const replacements = new Map([
      ['Choisir les options', t('chooseOptions')],
      ['Choisir', t('chooseProduct')],
      ['FILTRES', t('filters')],
      ['Filtres', t('filterHeading')],
      ['Filtrer', t('filterHeading')],
      ['Fermer', t('close')],
      ['Fermer les filtres', t('closeFilters')],
      ['TOUT SUPPRIMER', t('clearFilters')],
      ['Appliquer', t('applyFilters')],
      ['Quantité', t('quantity')],
      ['Taille', t('size')],
      ['Couleur', t('color')],
      ['Type de produit', t('type')],
      ['Disponibilité', t('availability')],
      ['En stock', t('inStock')],
      ['Épuisé', t('unavailable')],
      ['Epuisé', t('unavailable')],
      ['Combinaison non disponible', t('unavailableCombination')],
      ['Quantité max atteinte', t('stockLimit')]
    ]);

    return replacements.get(value) || text;
  };

  const syncProductModalLabels = (modal = getModalContainer()) => {
    if (!isEnglishLocale || !modal) return;

    [
      '.gbbProductQuantityHeading',
      '.gbbProductVariantNotAvailableWarning',
      '.gbbProductVariantOptionLabel',
      '.gbbProductVariantAddButton'
    ].forEach((selector) => {
      modal.querySelectorAll(selector).forEach((node) => {
        const localized = getLocalizedNativeText(node.textContent);
        if (localized !== node.textContent) node.textContent = localized;
      });
    });
  };

  const translateNativeBundleTexts = (root = document) => {
    if (!isEnglishLocale) return;

    const selectors = [
      '#gbbBundle .gbbAddProductPageSubtext',
      '#gbbBundle .gbbProductAddButton',
      '#gbbBundle .gbbDiscountMessage',
      '#gbbBundle .gbbFiltersSearchSortHeader',
      '#gbbBundle .gbbFiltersMainButtonWrapper',
      '#gbbBundle .gbbFiltersDropDownButton',
      '#gbbBundle .gbbFooterNextButton',
      '#gbbBundle .gbbViewCartProductsLink',
      '#gbbBundle .gbbProductVariantAddButton',
      '#gbbBundle .gbbProductQuantityHeading',
      '#gbbBundle .gbbProductQuantityLabel',
      '#gbbBundle .gbbProductVariantNotAvailableWarning',
      '#gbbBundle .gbbProductVariantOptionLabel',
      '.gbbProductVariantModalContainer .gbbProductVariantAddButton',
      '.gbbProductVariantModalContainer .gbbProductQuantityHeading',
      '.gbbProductVariantModalContainer .gbbProductVariantNotAvailableWarning',
      '.gbbProductVariantModalContainer .gbbProductVariantOptionLabel',
      '.gbbProductVariantAddButton',
      '.gbbProductQuantityHeading',
      '.gbbProductVariantNotAvailableWarning',
      '.gbbProductVariantOptionLabel',
      '#gbbBundle .gbbLoadMoreProductsButton',
      '#gbbBundle .mobile-facets__heading',
      '#gbbBundle .mobile-facets__count',
      '#gbbBundle .mobile-facets__close',
      '#gbbBundle .active-facets__button-remove-all',
      '#gbbBundle .mobile-facets__submit'
    ].join(',');
    const scope = root instanceof Element ? root : document;
    const candidates = [
      ...(scope.matches && scope.matches(selectors) ? [scope] : []),
      ...Array.from(scope.querySelectorAll ? scope.querySelectorAll(selectors) : [])
    ];

    candidates.forEach((node) => {
      const localized = getLocalizedNativeText(node.textContent);
      if (localized !== node.textContent) node.textContent = localized;

      ['aria-label', 'title'].forEach((attribute) => {
        const attributeValue = node.getAttribute && node.getAttribute(attribute);
        if (!attributeValue) return;
        const localizedAttribute = getLocalizedNativeText(attributeValue);
        if (localizedAttribute !== attributeValue) node.setAttribute(attribute, localizedAttribute);
      });
    });
  };

  const syncProductActionLabels = (root = document) => {
    if (!isEnglishLocale) return;

    const selector = '#gbbBundle .gbbProductAddButton';
    const scope = root instanceof Element ? root : document;
    const buttons = [
      ...(scope.matches && scope.matches(selector) ? [scope] : []),
      ...Array.from(scope.querySelectorAll ? scope.querySelectorAll(selector) : [])
    ];

    buttons.forEach((button) => {
      const current = normalizeText(button.textContent);
      const localizedLabel = t('chooseOptions');
      const shouldLocalize = [
        normalizeText('Choisir les options'),
        normalizeText('Choisir'),
        normalizeText(localizedLabel)
      ].includes(current);

      if (shouldLocalize && normalizeText(button.textContent) !== normalizeText(localizedLabel)) {
        button.textContent = localizedLabel;
      }

      if (shouldLocalize) {
        button.setAttribute('aria-label', localizedLabel);
        button.dataset.archiduchesseActionLabel = 'choose-options';
      }
    });
  };

  const scheduleNativeBundleTextTranslation = () => {
    if (!isEnglishLocale) return;

    nativeTextTranslationTimers.forEach((timer) => window.clearTimeout(timer));
    nativeTextTranslationTimers = [0, 80, 300, 900, 1800].map((delay) => (
      window.setTimeout(() => {
        syncBundleIntro();
        syncProductModalLabels();
        translateNativeBundleTexts();
        syncLocalizedSizeLabels();
        syncProductActionLabels();
      }, delay)
    ));
  };

  const startProductActionLabelGuard = () => {
    if (!isEnglishLocale || productActionLabelTimer) return;

    let missingBundleRuns = 0;
    let runs = 0;
    productActionLabelTimer = window.setInterval(() => {
      const hasBundle = Boolean(document.querySelector('#gbbBundle'));
      if (!hasBundle) {
        missingBundleRuns += 1;

        if (missingBundleRuns >= 5) {
          window.clearInterval(productActionLabelTimer);
          productActionLabelTimer = null;
        }

        return;
      }

      missingBundleRuns = 0;
      syncBundleIntro();
      syncProductModalLabels();
      syncLocalizedSizeLabels();
      syncProductActionLabels();
      runs += 1;

      if (runs >= 180) {
        window.clearInterval(productActionLabelTimer);
        productActionLabelTimer = null;
      }
    }, 1000);
  };

  const handleModalStockGuardClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const modal = event.target.closest('.gbbProductVariantModalContainer');
    if (!modal) return;

    const plusButton = event.target.closest('.gbbProductQuantityAddButton');
    const addButton = event.target.closest('.gbbProductVariantAddButton');
    const optionButton = event.target.closest('.gbbProductVariantOptionValue');

    if (optionButton) {
      window.setTimeout(() => syncProductModalStockState(modal), 0);
      window.setTimeout(() => syncProductModalStockState(modal), 80);
    }
    if (!plusButton && !addButton) return;

    const state = getModalStockState(modal);
    const hasPendingQuantitySync = modal.dataset.archiduchesseQuantitySyncPending === 'true';
    const isQuantityOverLimit = state.quantityLimit !== null && state.currentQuantity >= state.quantityLimit;
    const isAddOverLimit = state.quantityLimit !== null && (
      state.quantityLimit <= 0 || state.currentQuantity > state.quantityLimit
    );

    if (plusButton && (state.isSoldOut || isQuantityOverLimit)) {
      blockModalStockEvent(event);
      return;
    }

    if (addButton && (state.isSoldOut || hasPendingQuantitySync || isAddOverLimit)) {
      blockModalStockEvent(event);
      return;
    }

    window.setTimeout(() => syncProductModalStockState(modal), 0);
  };

  const shouldHandle = (event) => {
    if (event.defaultPrevented) return false;
    if (event.type === 'click' && event.button && event.button !== 0) return false;
    if (!(event.target instanceof Element)) return false;
    if (event.target.closest(ignoredSelector)) return false;
    return true;
  };

  const triggerChoice = (card) => {
    if (isSoldOutCard(card) || isStockPendingCard(card)) return false;

    rememberProductForCard(card);

    const button = getAddButton(card);
    if (!button) return false;

    button.click();
    return true;
  };

  const handleCardClick = (event) => {
    const card = event.target instanceof Element ? event.target.closest(cardSelector) : null;
    rememberProductForCard(card);

    if (!shouldHandle(event)) return;

    if (!card || !getAddButton(card)) return;

    event.preventDefault();
    event.stopPropagation();
    if (isSoldOutCard(card)) return;

    triggerChoice(card);
  };

  const handleCardKeydown = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const card = event.target instanceof Element ? event.target.closest(cardSelector) : null;
    rememberProductForCard(card);

    if (!shouldHandle(event)) return;

    if (!card || !getAddButton(card)) return;

    event.preventDefault();
    event.stopPropagation();
    if (isSoldOutCard(card)) return;

    triggerChoice(card);
  };

  const syncLoadingNotice = () => {
    const main = document.querySelector('#MainContent');
    const bundle = document.querySelector('#gbbBundle');
    if (!main || !bundle) return;

    let notice = main.querySelector('.gbbArchiduchesseLoadingNotice');
    const shouldShow = getProductCount() === 0;

    if (!shouldShow) {
      if (notice) notice.remove();
      return;
    }

    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'gbbArchiduchesseLoadingNotice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      notice.textContent = bundleConfig.loadingLabel;
      bundle.insertAdjacentElement('beforebegin', notice);
    }
  };

  const decorateLoadMoreButton = () => {
    const button = getLoadMoreButton();
    if (!button) return;

    button.setAttribute('role', 'button');
    button.setAttribute('aria-label', t('loadMoreProducts'));
    button.setAttribute('tabindex', '-1');
  };

  const decorateProductModalAccessibility = () => {
    const closeButton = document.querySelector('.gbbProductVariantModalClose');
    if (!closeButton) return;

    closeButton.setAttribute('role', 'button');
    closeButton.setAttribute('aria-label', t('close'));
    closeButton.setAttribute('title', t('close'));
    closeButton.setAttribute('tabindex', '0');
  };

  const handleAccessibleControlKeydown = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!(event.target instanceof Element)) return;

    const control = event.target.closest('.gbbProductVariantModalClose, .gbbLoadMoreProductsButton');
    if (!control) return;

    event.preventDefault();
    control.click();
  };

  const enhanceCards = (root = document) => {
    const cards = root.matches && root.matches(cardSelector)
      ? [root]
      : Array.from(root.querySelectorAll(cardSelector));

    cards.forEach((card) => {
      if (card.dataset.archiduchesseCardClick === 'true') return;

      const title = getTitle(card);
      card.dataset.archiduchesseCardClick = 'true';
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      if (title) card.setAttribute('aria-label', `${t('chooseProduct')} ${title}`);
    });
  };

  const updateProductCount = () => {
    const header = document.querySelector('#gbbBundle .gbbFiltersSearchSortHeader');
    if (!header) return;

    const count = getFilteredProducts().length || getProductCount();
    if (count) header.setAttribute('data-product-count', `${count} ${count === 1 ? t('productSingular') : t('productPlural')}`);
  };

  const getRequiredPairCount = () => {
    const heading = document.querySelector('#gbbBundle .gbbAddProductPageSubtext');
    const headingMatch = heading && heading.textContent.match(/(\d+)\s+produit/i);

    if (headingMatch) return Number(headingMatch[1]);
    return bundleConfig.pairCount;
  };

  const getRemainingPairCount = () => {
    const message = document.querySelector('#gbbBundle .gbbDiscountMessage');
    const messageText = message ? message.textContent : '';
    const remainingMatch = messageText.match(/ajout(?:er|ez)\s+(\d+)\s+produit/i);

    if (!remainingMatch && /discount has been applied|success|remise|reduction|réduction|appliqu|obtenu/i.test(normalizeText(messageText))) {
      return 0;
    }

    if (!remainingMatch) return null;
    return Number(remainingMatch[1]);
  };

  const getSelectedPairCount = () => {
    const targetCount = getRequiredPairCount();
    const remainingCount = getRemainingPairCount();

    if (Number.isFinite(remainingCount)) {
      return Math.max(0, Math.min(targetCount, targetCount - remainingCount));
    }

    const selectedItemSelectors = [
      '#gbbBundle .gbbSelectedProductItem',
      '#gbbBundle .gbbSelectedProductsContainer .gbbProductItem',
      '#gbbBundle .gbbBundleProductItem',
      '#gbbBundle .gbbBoxProductItem',
      '#gbbBundle .gbbCartProductItem'
    ];

    const selectedItems = selectedItemSelectors
      .map((selector) => Array.from(document.querySelectorAll(selector)))
      .find((items) => items.length) || [];

    const selectedCount = selectedItems.reduce((count, item) => {
      const quantityMatch = String(item.textContent || '').match(/(?:x|×|quantit[eé]\s*:?)\s*(\d+)/i);
      const quantity = quantityMatch ? Number(quantityMatch[1]) : 1;
      return count + (Number.isFinite(quantity) && quantity > 0 ? quantity : 1);
    }, 0);

    return Math.max(0, Math.min(targetCount, selectedCount));
  };

  const updateBundleFooter = () => {
    disableReviewStep();

    const footer = document.querySelector('#gbbBundle .gbbAddProductsPageFooterHTML');
    if (!footer) return;

    const targetCount = getRequiredPairCount();
    const selectedCount = getSelectedPairCount();
    const pairLabel = selectedCount === 1 ? t('pairSelectedSingular') : t('pairSelectedPlural');
    let status = footer.querySelector('.gbbArchiduchesseFooterStatus');

    if (!status) {
      status = document.createElement('div');
      status.className = 'gbbArchiduchesseFooterStatus';
      status.setAttribute('aria-live', 'polite');
      footer.insertAdjacentElement('afterbegin', status);
    }

    const statusText = `${selectedCount}/${targetCount} ${pairLabel}`;
    const isComplete = selectedCount >= targetCount ? 'true' : 'false';

    if (status.textContent !== statusText) status.textContent = statusText;
    if (footer.dataset.archiduchesseComplete !== isComplete) {
      footer.dataset.archiduchesseComplete = isComplete;
    }

    if (footer.dataset.archiduchesseSelectedCount !== String(selectedCount)) {
      footer.dataset.archiduchesseSelectedCount = String(selectedCount);
    }

    const viewLink = footer.querySelector('.gbbViewCartProductsLink');
    if (viewLink && window.matchMedia('(max-width: 900px)').matches) {
      if (selectedCount > 0) {
        const viewText = selectedCount === 1
          ? t('selectedProductSingular')
          : `${t('selectedProductsPlural')} (${selectedCount})`;

        if (normalizeText(viewLink.textContent) !== normalizeText(viewText)) {
          viewLink.textContent = viewText;
        }
      }
    }

    const nextButton = footer.querySelector('.gbbFooterNextButton');
    if (nextButton && !isDirectCartAddPending) {
      const buttonText = selectedCount >= targetCount ? directCartAddButtonLabel : bundleConfig.ctaContinueLabel;

      if (normalizeText(nextButton.textContent) !== normalizeText(buttonText)) {
        nextButton.textContent = buttonText;
      }

      nextButton.setAttribute('role', 'button');
      nextButton.setAttribute('aria-label', buttonText);
    }
  };

  const parseCartCount = (text) => {
    const counts = Array.from(String(text || '').matchAll(/\d+/g))
      .map((match) => Number(match[0]))
      .filter(Number.isFinite);

    return counts.length ? Math.max(...counts) : null;
  };

  const getVisibleCartItemCount = () => {
    const cartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble')
      || document.querySelector('#cart-icon-bubble');

    return cartBubble ? parseCartCount(cartBubble.textContent) : null;
  };

  const fetchCart = () => fetch('/cart.js', {
    cache: 'no-store',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then((response) => {
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    })
    .then((cart) => {
      const itemCount = Number(cart && cart.item_count);
      lastKnownCartItemCount = Number.isFinite(itemCount) ? itemCount : 0;
      return cart;
    });

  const fetchCartItemCount = () => fetchCart()
    .then((cart) => lastKnownCartItemCount);

  const closeOpenProductModal = () => {
    const modal = getModalContainer();
    if (!modal) return false;

    const closeButton = modal.querySelector('.gbbProductVariantModalClose');
    if (closeButton) {
      closeButton.click();
      return true;
    }

    return false;
  };

  const scrollCartDrawerToTop = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    [
      cartDrawer.querySelector('.drawer__inner'),
      cartDrawer.querySelector('cart-drawer-items'),
      cartDrawer.querySelector('#CartDrawer-CartItems')
    ].forEach((element) => {
      if (element && typeof element.scrollTo === 'function') {
        element.scrollTo({ top: 0, left: 0 });
      } else if (element) {
        element.scrollTop = 0;
      }
    });
  };

  const clearDirectCartFallbackTimer = () => {
    if (directCartFallbackTimer) {
      window.clearTimeout(directCartFallbackTimer);
      directCartFallbackTimer = null;
    }
  };

  const clearDirectCartAddState = () => {
    isDirectCartAddPending = false;

    if (directCartAddResetTimer) {
      window.clearTimeout(directCartAddResetTimer);
      directCartAddResetTimer = null;
    }

    if (directCartSubmitTimer) {
      window.clearTimeout(directCartSubmitTimer);
      directCartSubmitTimer = null;
    }

    clearDirectCartFallbackTimer();
    directCartFallbackAttempts = 0;
    directCartInitialItemCount = null;
    directCartSubmitAttempts = 0;
    document.documentElement.removeAttribute('data-archiduchesse-direct-cart-add');

    const footer = document.querySelector('#gbbBundle .gbbAddProductsPageFooterHTML');
    if (footer && footer.dataset.archiduchesseDirectCartPending) {
      delete footer.dataset.archiduchesseDirectCartPending;
    }

    updateBundleFooter();
  };

  const suppressPreparingBundleModal = () => {
    const runtime = getEasyBundleRuntime();
    const easyBundleUtility = runtime && runtime.utility;
    if (!easyBundleUtility) return false;

    document.querySelectorAll('.gbbPreparingBundleMainContainer').forEach((modal) => modal.remove());

    if (easyBundleUtility.renderPreparingBundleModal
      && easyBundleUtility.renderPreparingBundleModal.archiduchesseHidden === true) {
      return true;
    }

    if (typeof easyBundleUtility.renderPreparingBundleModal === 'function') {
      const hiddenPreparingBundleModal = () => {};
      hiddenPreparingBundleModal.archiduchesseHidden = true;
      easyBundleUtility.renderPreparingBundleModal = hiddenPreparingBundleModal;
    }

    return true;
  };

  const cartDrawerSectionHasItems = (sections) => {
    const sectionHTML = sections && sections['cart-drawer'];
    if (typeof sectionHTML !== 'string' || !sectionHTML.trim()) return false;

    const drawer = new DOMParser()
      .parseFromString(sectionHTML, 'text/html')
      .querySelector('#CartDrawer, .drawer__inner');

    return Boolean(drawer && drawer.querySelector('.cart-item'));
  };

  const refreshAndOpenCartDrawer = () => {
    closeOpenProductModal();

    const cartDrawer = document.querySelector('cart-drawer');
    const cartIcon = document.querySelector('#cart-icon-bubble');

    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
      if (cartIcon) cartIcon.click();
      return Promise.resolve(false);
    }

    const sectionIds = cartDrawer.getSectionsToRender
      ? cartDrawer.getSectionsToRender().map((section) => section.id).join(',')
      : 'cart-drawer,cart-icon-bubble';
    const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    const separator = cartUrl.includes('?') ? '&' : '?';
    const url = `${cartUrl}${separator}sections=${sectionIds}&sections_url=${encodeURIComponent(cartUrl)}`;

    return fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart sections unavailable');
        return response.json();
      })
      .then((sections) => {
        if (!sections || typeof sections !== 'object' || !cartDrawerSectionHasItems(sections)) {
          throw new Error('Cart sections empty');
        }

        cartDrawer.renderContents({
          id: 'archiduchesse-easybundle',
          sections,
          openDrawer: false,
          preserveCartImages: true
        });

        if (typeof cartDrawer.open === 'function') {
          window.setTimeout(() => {
            cartDrawer.open();
            scrollCartDrawerToTop();
          }, 0);
          window.setTimeout(scrollCartDrawerToTop, 180);
        }

        return true;
      })
      .catch(() => {
        if (cartIcon) cartIcon.click();
        return false;
      });
  };

  const waitForCartChange = () => new Promise((resolve) => {
    let attempts = 0;
    const maxAttempts = 12;

    const retry = () => {
      attempts += 1;

      fetchCart()
        .then((cart) => {
          const itemCount = Number(cart && cart.item_count);
          const initialItemCount = Number.isFinite(directCartInitialItemCount)
            ? directCartInitialItemCount
            : 0;

          if (Number.isFinite(itemCount) && itemCount > initialItemCount) {
            resolve(cart);
            return;
          }

          if (attempts >= maxAttempts) {
            resolve(cart || null);
            return;
          }

          window.setTimeout(retry, attempts < 5 ? 350 : 750);
        })
        .catch(() => {
          if (attempts >= 8) {
            resolve(null);
            return;
          }

          window.setTimeout(retry, 750);
      });
    };

    window.setTimeout(retry, 250);
  });

  const openCartDrawerAfterAdd = () => waitForCartChange()
    .then(() => refreshAndOpenCartDrawer());

  window.__archiduchesseEasyBundleAfterAdd = () => {
    if (bundleAfterAddInFlight) return;

    bundleAfterAddInFlight = true;

    openCartDrawerAfterAdd()
      .finally(() => {
        bundleAfterAddInFlight = false;
        clearDirectCartAddState();
      });
  };

  const scheduleDirectCartDrawerFallback = () => {
    clearDirectCartFallbackTimer();

    const retry = () => {
      if (!isDirectCartAddPending) {
        clearDirectCartFallbackTimer();
        return;
      }

      directCartFallbackAttempts += 1;

      fetchCartItemCount()
        .then((itemCount) => {
          const initialItemCount = Number.isFinite(directCartInitialItemCount)
            ? directCartInitialItemCount
            : 0;
          const cartHasChanged = Number.isFinite(initialItemCount)
            ? itemCount > initialItemCount
            : itemCount > 0;
          const shouldOpenDrawer = cartHasChanged
            || (directCartFallbackAttempts >= 8 && itemCount > 0);

          if (shouldOpenDrawer) {
            if (bundleAfterAddInFlight) {
              directCartFallbackTimer = window.setTimeout(retry, 500);
              return;
            }

            openCartDrawerAfterAdd().finally(clearDirectCartAddState);
            return;
          }

          if (directCartFallbackAttempts >= 24) {
            clearDirectCartAddState();
            return;
          }

          directCartFallbackTimer = window.setTimeout(
            retry,
            directCartFallbackAttempts < 5 ? 500 : 1000
          );
        })
        .catch(() => {
          if (directCartFallbackAttempts >= 12) {
            if (!bundleAfterAddInFlight) {
              openCartDrawerAfterAdd().finally(clearDirectCartAddState);
            }
            return;
          }

          directCartFallbackTimer = window.setTimeout(retry, 1000);
        });
    };

    directCartFallbackTimer = window.setTimeout(retry, 800);
  };

  const setDirectCartAddState = (button) => {
    isDirectCartAddPending = true;
    directCartFallbackAttempts = 0;
    directCartInitialItemCount = Number.isFinite(lastKnownCartItemCount)
      ? lastKnownCartItemCount
      : null;
    fetchCart()
      .then(() => {
        if (isDirectCartAddPending) directCartInitialItemCount = lastKnownCartItemCount;
      })
      .catch(() => {});
    configureDirectCartRedirect();
    suppressPreparingBundleModal();
    document.documentElement.setAttribute('data-archiduchesse-direct-cart-add', 'true');

    const footer = document.querySelector('#gbbBundle .gbbAddProductsPageFooterHTML');
    if (footer && footer.dataset.archiduchesseDirectCartPending !== 'true') {
      footer.dataset.archiduchesseDirectCartPending = 'true';
    }

    if (button && normalizeText(button.textContent) !== normalizeText(directCartPendingButtonLabel)) {
      button.textContent = directCartPendingButtonLabel;
      button.setAttribute('aria-label', directCartPendingButtonLabel);
    }

    if (directCartAddResetTimer) window.clearTimeout(directCartAddResetTimer);
    directCartAddResetTimer = window.setTimeout(clearDirectCartAddState, 12000);
    scheduleDirectCartDrawerFallback();
  };

  const configureDirectCartRedirect = () => {
    const easyBundleAppSettings = getEasyBundleAppSettings();

    if (!easyBundleAppSettings) return false;

    if (easyBundleAppSettings.redirectToScript !== postBundleRedirectScript) {
      easyBundleAppSettings.redirectToScript = postBundleRedirectScript;
    }

    if (easyBundleAppSettings.redirectToCartEnabled !== false) {
      easyBundleAppSettings.redirectToCartEnabled = false;
    }

    if (easyBundleAppSettings.redirectToCheckoutEnabled !== false) {
      easyBundleAppSettings.redirectToCheckoutEnabled = false;
    }

    return true;
  };

  const disableReviewStep = () => {
    const easyBundle = getEasyBundleRuntime();
    if (!easyBundle) return false;

    configureDirectCartRedirect();
    suppressPreparingBundleModal();

    const summaryPageData = easyBundle.settings
      && easyBundle.settings.stepsConfigurationData
      && easyBundle.settings.stepsConfigurationData.summaryPageData;

    if (summaryPageData && summaryPageData.isSummaryPageEnabled !== false) {
      summaryPageData.isSummaryPageEnabled = false;
    }

    if (!easyBundle.state || !Array.isArray(easyBundle.state.navigationItems)) return false;

    const filteredNavigationItems = easyBundle.state.navigationItems.filter((item) => (
      item && item.id !== 'reviewPage'
    ));

    if (filteredNavigationItems.length !== easyBundle.state.navigationItems.length) {
      easyBundle.state.navigationItems = filteredNavigationItems;
      return true;
    }

    return false;
  };

  const maybeSubmitReviewPage = () => {
    if (!isDirectCartAddPending) return false;

    const checkoutButton = document.querySelector('#gbbBundle .gbbSummaryPageCheckoutButton');
    if (!checkoutButton || checkoutButton.classList.contains('gbbDisabled')) return false;

    checkoutButton.click();
    return true;
  };

  const scheduleDirectCartSubmitAttempts = () => {
    if (directCartSubmitTimer) window.clearTimeout(directCartSubmitTimer);

    directCartSubmitTimer = window.setTimeout(() => {
      directCartSubmitAttempts += 1;

      if (maybeSubmitReviewPage() || !isDirectCartAddPending || directCartSubmitAttempts >= 24) {
        directCartSubmitTimer = null;
        return;
      }

      scheduleDirectCartSubmitAttempts();
    }, directCartSubmitAttempts < 4 ? 250 : 500);
  };

  const handleDirectCartContinueClick = (event) => {
    if (event.defaultPrevented || isDirectCartAddPending) return;
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('#gbbBundle .gbbFooterNextButton');
    if (!button) return;

    const footer = button.closest('.gbbAddProductsPageFooterHTML');
    if (!footer || footer.dataset.archiduchesseComplete !== 'true') return;

    disableReviewStep();
    setDirectCartAddState(button);
    scheduleDirectCartSubmitAttempts();
  };

  const scheduleGlobalStockSync = () => {
    if (globalStockSyncTimer) window.clearTimeout(globalStockSyncTimer);
    globalStockSyncTimer = window.setTimeout(() => {
      globalStockSyncTimer = null;
      if (!getModalContainer() && !document.querySelector('#gbbBundle .gbbAddProductsPageFooterHTML')) return;
      syncProductModalStockState();
      updateBundleFooter();
    }, 250);
  };

  document.addEventListener('click', handleDirectCartContinueClick, true);
  document.addEventListener('click', handleCollectionControlsClick, true);
  document.addEventListener('change', handleCollectionControlsChange, true);
  document.addEventListener('click', handleModalStockGuardClick, true);
  document.addEventListener('click', handleCardClick, true);
  document.addEventListener('click', scheduleGlobalStockSync, true);
  document.addEventListener('keydown', handleAccessibleControlKeydown, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCollectionFacets();
  }, true);
  document.addEventListener('keydown', handleCardKeydown, true);
  document.addEventListener('keydown', scheduleGlobalStockSync, true);
  document.addEventListener('gbb-page-load', () => {
    closeCollectionFacets();
    disableReviewStep();
    syncBundleIntro();
    syncLocalizedSizeLabels();
    scheduleNativeBundleTextTranslation();
  });
  document.addEventListener('gbb-footer-rendered', () => {
    disableReviewStep();
    syncBundleIntro();
    updateBundleFooter();
    syncLocalizedSizeLabels();
    scheduleNativeBundleTextTranslation();
  });
  document.addEventListener('gbb-checkout-success', window.__archiduchesseEasyBundleAfterAdd);
  document.addEventListener('gbb-checkout-failed', clearDirectCartAddState);
  hideNativeBundleFilters();
  closeCollectionFacets();
  syncLoadingNotice();
  removeExcludedProductCards();
  enhanceCards();
  syncProductCategories();
  syncProductActionLabels();
  syncCardFilterData();
  renderCollectionControls();
  renderCurrentProductPage({ force: true });
  syncProductModal();
  syncBundleIntro();
  translateNativeBundleTexts();
  syncLocalizedSizeLabels();
  syncProductActionLabels();
  decorateLoadMoreButton();
  decorateProductModalAccessibility();
  disableReviewStep();
  suppressPreparingBundleModal();
  updateProductCount();
  updateBundleFooter();
  translateNativeBundleTexts();
  syncLocalizedSizeLabels();
  syncProductActionLabels();
  scheduleNativeBundleTextTranslation();
  startProductActionLabelGuard();
  enrichBundleProductsFromDynamicCollection()
    .catch((error) => {
      console.warn('[archiduchesse] Nouveautés coffret indisponibles.', error);
    })
    .finally(scheduleProductMetaEnrichment);
  fetchCartItemCount().catch(() => {});

  const observer = new MutationObserver(scheduleDomSync);

  observer.observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();
